"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2413],{

/***/ 42413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AppLayout_AppLayout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
// EXTERNAL MODULE: ./src/hooks/useScrollIsShow.ts
var useScrollIsShow = __webpack_require__(76994);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-0bfff5899a/0/cache/@design-system-pc-npm-4.5.5-5209ca23ee-508cb735dc.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(56341);
// EXTERNAL MODULE: ./src/constants/index.ts + 7 modules
var constants = __webpack_require__(14054);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-redux-virtual-d8cdb1e912/0/cache/react-redux-npm-8.0.4-ee216b0e53-fd940de6a6.zip/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(65703);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
// EXTERNAL MODULE: ./src/hooks/useAuthenticated.ts
var useAuthenticated = __webpack_require__(90457);
// EXTERNAL MODULE: ./src/di-container/auth/gateway/client.ts
var client = __webpack_require__(2885);
// EXTERNAL MODULE: ./src/di-container/axios.ts
var axios = __webpack_require__(43856);
// EXTERNAL MODULE: ../../shared/common/src/index.ts + 9 modules
var src = __webpack_require__(61462);
;// CONCATENATED MODULE: ./src/di-container/common/cart/gateway/client.ts


var cartGateway = function() {
    return {
        getCount: new src/* GetCartCountGateway */.rd(axios/* axios */.o)
    };
};

// EXTERNAL MODULE: ./src/redux/reducers/gnb.ts
var gnb = __webpack_require__(27507);
// EXTERNAL MODULE: ./src/di-container/display/gateway/client.ts
var gateway_client = __webpack_require__(4986);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(98749);
;// CONCATENATED MODULE: ./src/ui/Header/hooks/useHeader.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}












var useHeader = function(props) {
    var ref = props !== null && props !== void 0 ? props : {}, _isBackgroundColor = ref.isBackgroundColor, isBackgroundColor = _isBackgroundColor === void 0 ? true : _isBackgroundColor, _isWelcomePage = ref.isWelcomePage, isWelcomePage = _isWelcomePage === void 0 ? false : _isWelcomePage;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var store = (0,es/* useStore */.oR)();
    var ref1 = (0,useAuthenticated/* default */.Z)(), isAuthenticated = ref1.isAuthenticated, custNo = ref1.custNo;
    var ref2 = (0,client/* authGateway */.h)(store.dispatch), loginGateway = ref2.loginGateway, logoutGateway = ref2.logoutGateway;
    var ref3 = (0,react.useState)(true), isGnbShow = ref3[0], setIsGnbShow = ref3[1];
    var ref4 = (0,react.useState)(!isBackgroundColor), isTransparentBackground = ref4[0], setIsTransparentBackground = ref4[1];
    var ref5 = (0,react.useState)(constants/* GNB_TYPE_VALUE.MALL */.CoW.MALL), viewType = ref5[0], setViewType = ref5[1];
    var ref6 = (0,react.useState)(0), scrollPosition = ref6[0], setScrollPosition = ref6[1];
    var ref7 = (0,react.useState)(false), isMenuTitleEnter = ref7[0], setIsMenuTitleEnter = ref7[1];
    var ref8 = (0,react.useState)(false), isHeaderMouseEnter = ref8[0], setIsHeaderMouseEnter = ref8[1];
    var ref9 = (0,react.useState)(false), isShowMallCategory = ref9[0], setIsShowMallCategory = ref9[1];
    var ref10 = (0,react.useState)(false), isShowInteriorCategory = ref10[0], setIsShowInteriorCategory = ref10[1];
    var ref11 = (0,react.useState)(false), isShowSearchInput = ref11[0], setIsShowSearchInput = ref11[1];
    var ref12 = (0,react.useState)(""), enteredIcon = ref12[0], setEnteredIcon = ref12[1];
    var ref13 = (0,react.useState)(0), cartCount = ref13[0], setCartCount = ref13[1];
    var isBackgroundColorActive = (0,react.useMemo)(function() {
        return !isWelcomePage && (isBackgroundColor || isHeaderMouseEnter || !isTransparentBackground);
    }, [
        isWelcomePage,
        isBackgroundColor,
        isHeaderMouseEnter,
        isTransparentBackground, 
    ]);
    var isGnbDefaultShow = (0,react.useMemo)(function() {
        if (pathname === "/my/consult" || pathname === "/my/visit-consult" || pathname === "/my/budget-expect") {
            return false;
        } else return true;
    }, [
        pathname
    ]);
    var handleRouter = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(value) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = value;
                        _ctx.next = _ctx.t0 === "HOME" ? 3 : _ctx.t0 === "MALL" ? 5 : _ctx.t0 === "INTERIOR" ? 7 : _ctx.t0 === "SHOP_SEARCH" ? 9 : _ctx.t0 === "CART" ? 11 : _ctx.t0 === "LOGIN" ? 13 : _ctx.t0 === "JOIN" ? 16 : _ctx.t0 === "LOGOUT" ? 18 : _ctx.t0 === "MY" ? 21 : 23;
                        break;
                    case 3:
                        router.push("".concat("https://store.hanssem.com", "/"));
                        return _ctx.abrupt("break", 23);
                    case 5:
                        router.push("".concat("https://store.hanssem.com", "/furnishing"));
                        return _ctx.abrupt("break", 23);
                    case 7:
                        router.push("".concat("https://store.hanssem.com", "/interior"));
                        return _ctx.abrupt("break", 23);
                    case 9:
                        router.push("/shop/search");
                        return _ctx.abrupt("break", 23);
                    case 11:
                        router.push("".concat("https://mall.hanssem.com", "/order/goCart.do?util=shopping"));
                        return _ctx.abrupt("break", 23);
                    case 13:
                        _ctx.next = 15;
                        return loginGateway.exec();
                    case 15:
                        return _ctx.abrupt("break", 23);
                    case 16:
                        // handleOpenJoinPopup();
                        router.push("".concat("https://mall.hanssem.com", "/customer/newMembershipCerti.do?util=join"));
                        return _ctx.abrupt("break", 23);
                    case 18:
                        _ctx.next = 20;
                        return logoutGateway.exec();
                    case 20:
                        return _ctx.abrupt("break", 23);
                    case 21:
                        isAuthenticated ? router.push("".concat("https://mall.hanssem.com", "/mypage/mypageMain.do?util=my")) : router.push("".concat("https://mall.hanssem.com", "/mypage/mypageMainNonmember.do?util=my"));
                        return _ctx.abrupt("break", 23);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isAuthenticated,
        loginGateway,
        logoutGateway,
        router
    ]);
    var handleIsMenuTitleEnter = function() {
        if (pathname === "/my/consult" || pathname === "/my/visit-consult" || pathname === "/my/budget-expect") {
            store.dispatch(gnb/* default.actions.setIsHeaderShow */.ZP.actions.setIsHeaderShow(true));
        }
        setIsMenuTitleEnter(true);
    };
    var handleIsMenuTitleLeave = function() {
        setIsMenuTitleEnter(false);
    };
    var handleIsShowSearchInput = (0,react.useCallback)(function(isShow) {
        setIsShowSearchInput(isShow);
    }, []);
    var getCount = cartGateway().getCount;
    (0,react.useEffect)(function() {
        getCount.exec({
            custNo: custNo
        }).then(function(apiResponse) {
            if (apiResponse.code === 200) {
                var ref;
                setCartCount(((ref = apiResponse.data) === null || ref === void 0 ? void 0 : ref.cartCnt) || 0);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        custNo
    ]);
    /** GNB showing 스크롤 이벤트 */ (0,react.useEffect)(function() {
        var lastScrollY = 0;
        var handleHeaderScroll = (0,lodash.throttle)(function() {
            var scrollY = window.scrollY;
            // 이전의 스크롤 위치와 비교하기
            var direction = scrollY > lastScrollY ? "DOWN" : "UP";
            // 현재의 스크롤 값을 저장
            lastScrollY = scrollY;
            setScrollPosition(lastScrollY);
            if (direction === "DOWN") {
                store.dispatch(gnb/* default.actions.setIsHeaderShow */.ZP.actions.setIsHeaderShow(false));
                setIsGnbShow(false);
            } else if (direction === "UP") {
                if (pathname !== "/my/consult" && pathname !== "/my/visit-consult" && pathname !== "/my/budget-expect") {
                    store.dispatch(gnb/* default.actions.setIsHeaderShow */.ZP.actions.setIsHeaderShow(true));
                    setIsGnbShow(true);
                }
            }
        }, 100);
        window.addEventListener("scroll", handleHeaderScroll);
        return function() {
            return window.removeEventListener("scroll", handleHeaderScroll);
        };
    }, [
        isGnbDefaultShow,
        pathname,
        store
    ]);
    (0,react.useEffect)(function() {
        var handleTranslateBackground = function() {
            if (!isBackgroundColor) {
                setIsTransparentBackground(true);
            }
            if (window.scrollY === 0) {
                setIsTransparentBackground(true);
            } else {
                setIsTransparentBackground(false);
            }
        };
        window.addEventListener("scroll", handleTranslateBackground);
        return function() {
            return window.removeEventListener("scroll", handleTranslateBackground);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var getHamburgerMenus = (0,gateway_client/* displayGateway */.Q)().getHamburgerMenus;
    var menuFetcher = function(req) {
        return getHamburgerMenus.exec(req);
    };
    var ref14 = (0,dist/* default */.ZP)({
        gateway: "menus",
        typeValue: "PC",
        viewType: "ALL"
    }, menuFetcher), categoryApiResponseData = ref14.data;
    var sectionMenuList = (0,react.useMemo)(function() {
        var ref;
        return (categoryApiResponseData === null || categoryApiResponseData === void 0 ? void 0 : categoryApiResponseData.code) === 200 ? (categoryApiResponseData === null || categoryApiResponseData === void 0 ? void 0 : (ref = categoryApiResponseData.data) === null || ref === void 0 ? void 0 : ref.sectionMenuList) || [] : undefined;
    }, [
        categoryApiResponseData
    ]);
    var mallSectionMenu = (0,react.useMemo)(function() {
        if (sectionMenuList) {
            return sectionMenuList.find(function(item) {
                return item.mallType === "MALL";
            });
        } else {
            return null;
        }
    }, [
        sectionMenuList
    ]);
    var interiorSectionMenu = (0,react.useMemo)(function() {
        if (sectionMenuList) {
            return sectionMenuList.find(function(item) {
                return item.mallType === "REMODELING";
            });
        } else {
            return null;
        }
    }, [
        sectionMenuList
    ]);
    return {
        scrollPosition: scrollPosition,
        isGnbShow: isGnbShow,
        isAuthenticated: isAuthenticated,
        setIsGnbShow: setIsGnbShow,
        handleRouter: handleRouter,
        viewType: viewType,
        setViewType: setViewType,
        isBackgroundColorActive: isBackgroundColorActive,
        isGnbDefaultShow: isGnbDefaultShow,
        isMenuTitleEnter: isMenuTitleEnter,
        handleIsMenuTitleEnter: handleIsMenuTitleEnter,
        setIsHeaderMouseEnter: setIsHeaderMouseEnter,
        handleIsMenuTitleLeave: handleIsMenuTitleLeave,
        mallSectionMenu: mallSectionMenu,
        interiorSectionMenu: interiorSectionMenu,
        isShowMallCategory: isShowMallCategory,
        setIsShowMallCategory: setIsShowMallCategory,
        isShowInteriorCategory: isShowInteriorCategory,
        setIsShowInteriorCategory: setIsShowInteriorCategory,
        isShowSearchInput: isShowSearchInput,
        setIsShowSearchInput: setIsShowSearchInput,
        handleIsShowSearchInput: handleIsShowSearchInput,
        enteredIcon: enteredIcon,
        setEnteredIcon: setEnteredIcon,
        cartCount: cartCount
    };
};
/* harmony default export */ var hooks_useHeader = (useHeader);

// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
;// CONCATENATED MODULE: ./src/ui/Icons/Close32Icon.tsx


function Close32Icon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "8.4585",
                y: "9.40039",
                width: "1.33333",
                height: "20",
                rx: "0.666667",
                transform: "rotate(-45 8.4585 9.40039)",
                fill: "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "22.5991",
                y: "8.45703",
                width: "1.33333",
                height: "20",
                rx: "0.666667",
                transform: "rotate(45 22.5991 8.45703)",
                fill: "#121212"
            })
        ]
    });
}
/* harmony default export */ var Icons_Close32Icon = (Close32Icon);

;// CONCATENATED MODULE: ./src/ui/Icons/Search28Icon.tsx


var Search28Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.6 20.3C16.8526 20.3 20.3 16.8526 20.3 12.6C20.3 8.34741 16.8526 4.9 12.6 4.9C8.34741 4.9 4.9 8.34741 4.9 12.6C4.9 16.8526 8.34741 20.3 12.6 20.3ZM12.6 21.7C17.6258 21.7 21.7 17.6258 21.7 12.6C21.7 7.57421 17.6258 3.5 12.6 3.5C7.57421 3.5 3.5 7.57421 3.5 12.6C3.5 17.6258 7.57421 21.7 12.6 21.7Z",
                fill: "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.0955 18.1134C18.369 17.8402 18.8122 17.8404 19.0855 18.1139L24.2952 23.3288C24.5685 23.6023 24.5682 24.0455 24.2947 24.3187C24.0212 24.592 23.578 24.5918 23.3048 24.3182L18.095 19.1033C17.8218 18.8298 17.822 18.3866 18.0955 18.1134Z",
                fill: "#121212"
            })
        ]
    });
};
/* harmony default export */ var Icons_Search28Icon = (Search28Icon);

// EXTERNAL MODULE: ./src/ui/Tab3/index.ts + 2 modules
var Tab3 = __webpack_require__(5442);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.29.3-fef7e3c72c-e01cf5b62a.zip/node_modules/date-fns/esm/format/index.js + 6 modules
var format = __webpack_require__(22969);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.29.3-fef7e3c72c-e01cf5b62a.zip/node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(30426);
// EXTERNAL MODULE: ../../.yarn/cache/nookies-npm-2.5.2-691fdd44ab-4cc6fd8d0a.zip/node_modules/nookies/dist/index.js
var nookies_dist = __webpack_require__(34752);
// EXTERNAL MODULE: ./src/hooks/index.tsx + 5 modules
var hooks = __webpack_require__(93951);
// EXTERNAL MODULE: ./src/providers/ModalProvider/ModalProvider.tsx + 1 modules
var ModalProvider = __webpack_require__(72244);
// EXTERNAL MODULE: ./src/services/baseAxios.ts
var baseAxios = __webpack_require__(34887);
// EXTERNAL MODULE: ../../shared/base/src/utils/index.ts
var utils = __webpack_require__(93282);
;// CONCATENATED MODULE: ./src/di-container/searchAxios.ts
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function searchAxios_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function searchAxios_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                searchAxios_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                searchAxios_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var RefreshAxios = /*#__PURE__*/ function(BaseAxios) {
    "use strict";
    _inherits(RefreshAxios, BaseAxios);
    var _super = _createSuper(RefreshAxios);
    function RefreshAxios(config) {
        _classCallCheck(this, RefreshAxios);
        var _this;
        _this = _super.call(this, config);
        _this.config = config;
        return _this;
    }
    var _proto = RefreshAxios.prototype;
    _proto.requestInterceptor = function requestInterceptor(store) {};
    _proto.responseInterceptor = function responseInterceptor(store) {};
    return RefreshAxios;
}(baseAxios/* default */.Z);
var Axios = /*#__PURE__*/ function(BaseAxios) {
    "use strict";
    _inherits(Axios, BaseAxios);
    var _super = _createSuper(Axios);
    function Axios(config) {
        _classCallCheck(this, Axios);
        var _this;
        _this = _super.call(this, config);
        _this.config = config;
        return _this;
    }
    var _proto = Axios.prototype;
    _proto.requestInterceptor = function requestInterceptor(store) {
        this.requestInterceptorSeq = this.instance.interceptors.request.use(function(config) {
            var ref;
            var auth = store.getState().auth;
            if (auth.isAuthenticated && ((ref = auth.authInfo) === null || ref === void 0 ? void 0 : ref.accessToken)) {
                config.headers = _objectSpread({}, config.headers);
            }
            return config;
        }, function(error) {
            return Promise.reject(error);
        });
    };
    _proto.responseInterceptor = function responseInterceptor(store) {
        var _this = this;
        this.responseInterceptorSeq = this.instance.interceptors.response.use(function() {
            var _ref = searchAxios_asyncToGenerator(runtime_default().mark(function _callee(response) {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this.refresh(response, store);
                        case 2:
                            result = _ctx.sent;
                            _this._serverRefreshTokenGateway = undefined;
                            if (!((result === null || result === void 0 ? void 0 : result.code) === "200")) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", _this.instance(_objectSpread({}, response.config)));
                        case 6:
                            return _ctx.abrupt("return", response);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }(), function(error) {
            return Promise.reject(error);
        });
    };
    _proto.responseLogging = function responseLogging(response) {
        var originalRequest = response.config;
        ;
        ;
        ;
        ;
        ;
        ;
        ;
    };
    _proto.refresh = function refresh(response, store) {
        var _this = this;
        return searchAxios_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, request, auth, isRefreshStatus, ref3, _authInfo, accessToken, refreshToken, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        request = response.config;
                        auth = store.getState().auth;
                        isRefreshStatus = function(code) {
                            return code === 10001 || code === 10002 || code === 405 || code === 406;
                        };
                        if (!(!request._retry && ((ref = auth.authInfo) === null || ref === void 0 ? void 0 : ref.accessToken) && ((ref1 = auth.authInfo) === null || ref1 === void 0 ? void 0 : ref1.refreshToken) && isRefreshStatus(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.code))) {
                            _ctx.next = 20;
                            break;
                        }
                        ;
                        request._retry = true;
                        _authInfo = auth.authInfo, accessToken = _authInfo.accessToken, refreshToken = _authInfo.refreshToken;
                        if (!(0,utils/* isClient */.C5)()) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 11;
                        return (0,client/* authGateway */.h)(store.dispatch).refreshTokenGateway.exec();
                    case 11:
                        _ctx.t0 = _ctx.sent;
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.next = 16;
                        return (ref3 = _this._serverRefreshTokenGateway) === null || ref3 === void 0 ? void 0 : ref3.exec({
                            accessToken: accessToken,
                            refreshToken: refreshToken
                        });
                    case 16:
                        _ctx.t0 = _ctx.sent;
                    case 17:
                        result = _ctx.t0;
                        ;
                        return _ctx.abrupt("return", result);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _createClass(Axios, [
        {
            key: "refreshTokenGateway",
            set: function set(gateway) {
                this._serverRefreshTokenGateway = gateway;
            }
        }
    ]);
    return Axios;
}(baseAxios/* default */.Z);
var refreshAxios = new RefreshAxios();
var searchAxios = new Axios();

;// CONCATENATED MODULE: ./src/di-container/search/gateway/client.ts


var searchGateway = function() {
    return {
        getAutoComplete: new src/* GetXSearchAutoCompleteGateway */.Mr(searchAxios),
        getSuggest: new src/* GetXSearchSuggestGateway */.An(searchAxios),
        getRanking: new src/* GetXSearchRankingGateway */.z7(searchAxios)
    };
};

// EXTERNAL MODULE: ./src/providers/BrazeProvider/index.tsx + 1 modules
var BrazeProvider = __webpack_require__(53590);
;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/hooks/useGnbSearch.tsx
function useGnbSearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGnbSearch_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGnbSearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGnbSearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









var useGnbSearch = function() {
    var router = (0,next_router.useRouter)();
    var handleOpen = (0,ModalProvider/* useModal */.d)().handleOpen;
    var ref = searchGateway(), getAutoComplete = ref.getAutoComplete, getRanking = ref.getRanking, getSuggest = ref.getSuggest;
    var ref1 = (0,react.useState)(""), searchKey = ref1[0], setSearchKey = ref1[1];
    var ref2 = (0,react.useState)(), rankList = ref2[0], setRankList = ref2[1];
    var ref3 = (0,react.useState)([]), suggestList = ref3[0], setSuggestList = ref3[1];
    var ref4 = (0,react.useState)([]), autoList = ref4[0], setAutoList = ref4[1];
    var ref5 = (0,react.useState)([]), recentList = ref5[0], setRecentList = ref5[1];
    var COOKIE_SEPERATOR2 = "|";
    var COOKIE_SEPERATOR = "__";
    var HSM_RECENT_COOKIE_KEY = "hsm_konan-recent2";
    var ref6 = (0,react.useState)(false), state = ref6[0], setState = ref6[1];
    var ref7 = (0,react.useState)("최근 검색어"), tab = ref7[0], setTab = ref7[1];
    var inputRef = (0,react.useRef)(null);
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    (0,hooks/* useOnClickOutside */.t$)(inputRef, function() {
        setState(false);
    });
    // 자동완성 중복 제거
    var removeDuplicates = function(array) {
        var uniqueSet = new Set(array.map(function(item) {
            return JSON.stringify(item);
        }));
        var uniqueArray = Array.from(uniqueSet).map(function(item) {
            return JSON.parse(item);
        });
        return uniqueArray;
    };
    var autoComplete = (0,react.useCallback)(function() {
        var _ref = useGnbSearch_asyncToGenerator(runtime_default().mark(function _callee(value) {
            var suggestions, returnValue;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!value || /^\s*$/.test(value))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return getAutoComplete.exec({
                            term: value
                        });
                    case 4:
                        suggestions = _ctx.sent.suggestions;
                        if (suggestions && suggestions.length > 0) {
                            returnValue = removeDuplicates(suggestions[0]);
                            setAutoList(returnValue.map(function(item) {
                                return item[0];
                            }));
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getAutoComplete
    ]);
    var ranking = (0,react.useCallback)(useGnbSearch_asyncToGenerator(runtime_default().mark(function _callee() {
        var arr;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getRanking.exec({});
                case 2:
                    arr = _ctx.sent;
                    if (arr) {
                        setRankList(Object.values(arr));
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        getRanking
    ]);
    var suggest = (0,react.useCallback)(useGnbSearch_asyncToGenerator(runtime_default().mark(function _callee() {
        var arr;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(recentList.length === 0)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return getSuggest.exec({
                        term: recentList[0]
                    });
                case 4:
                    arr = _ctx.sent;
                    if (!(Object.entries(arr).length === 0)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 7:
                    setSuggestList(Object.values(arr));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        recentList,
        getSuggest
    ]);
    var getResentCookies = (0,react.useCallback)(function() {
        var ref;
        var recentKey = (ref = (0,nookies_dist.parseCookies)(null)) === null || ref === void 0 ? void 0 : ref[HSM_RECENT_COOKIE_KEY];
        if (!recentKey) return [];
        var items = unescape(recentKey).split(COOKIE_SEPERATOR);
        var result = items.map(function(item) {
            return item.split(COOKIE_SEPERATOR2)[0];
        });
        setRecentList(result.slice(0, 10));
        return result;
    }, []);
    var setResentCookies = (0,react.useCallback)(function(clickValue) {
        if (!searchKey && !clickValue) return;
        var toDay = new Date();
        var formatDate = (0,format/* default */.Z)(toDay, "yyyyMMdd");
        var recents = getResentCookies().filter(function(item) {
            return clickValue ? item !== clickValue : item !== searchKey;
        });
        recents.unshift(clickValue || searchKey);
        var value = escape(recents.map(function(text) {
            return text + COOKIE_SEPERATOR2 + formatDate;
        }).join(COOKIE_SEPERATOR));
        (0,nookies_dist.setCookie)(null, HSM_RECENT_COOKIE_KEY, value, {
            path: "/",
            domain: ".hanssem.com",
            expires: (0,addDays/* default */.Z)(new Date(), 365)
        });
        getResentCookies();
    }, [
        getResentCookies,
        searchKey
    ]);
    var handleLinkOpen = (0,react.useCallback)(function() {
        var _ref = useGnbSearch_asyncToGenerator(runtime_default().mark(function _callee(keyValue) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setResentCookies(keyValue);
                        router.push({
                            pathname: "".concat("https://mall.hanssem.com", "/search/search.do"),
                            query: {
                                term: searchKey,
                                searchKey: keyValue || searchKey,
                                searchTab: "goods"
                            }
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(keyValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        searchKey,
        router,
        setResentCookies
    ]);
    var handleEnter = function(e) {
        e.preventDefault();
        // 검색어가 없거나 빈 값인 경우 alert창 노출
        if (searchKey && !/^\s*$/.test(searchKey)) {
            setResentCookies();
            handleLinkOpen(searchKey);
            logCustomEvent({
                eventName: "bz_search",
                eventProperties: {
                    bz_keyword: searchKey,
                    bz_date: (0,format/* default */.Z)(new Date(), "yyyy-MM-dd")
                }
            });
        } else {
            handleOpen({
                modalProps: {
                    type: "alert",
                    text: "검색어를 입력해 주십시오."
                }
            });
        }
    };
    var clearCookies = function() {
        (0,nookies_dist.setCookie)(null, HSM_RECENT_COOKIE_KEY, "", {
            path: "/",
            // domain: 'local.remodeling.hanssem.com',
            domain: ".hanssem.com",
            expires: (0,addDays/* default */.Z)(new Date(), 365)
        });
        setRecentList([]);
        setSuggestList([]);
    };
    var deleteCookie = function(keyValue) {
        var recents = getResentCookies().filter(function(item) {
            return item !== keyValue;
        });
        var toDay = new Date();
        var formatDate = (0,format/* default */.Z)(toDay, "yyyyMMdd");
        var value = escape(recents.map(function(text) {
            return text + COOKIE_SEPERATOR2 + formatDate;
        }).join(COOKIE_SEPERATOR));
        (0,nookies_dist.setCookie)(null, HSM_RECENT_COOKIE_KEY, value, {
            path: "/",
            domain: ".hanssem.com",
            expires: (0,addDays/* default */.Z)(new Date(), 365)
        });
        setRecentList(recents);
        suggest();
    };
    (0,react.useEffect)(function() {
        ranking();
        getResentCookies();
        suggest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        suggest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recentList
    ]);
    (0,react.useEffect)(function() {
        autoComplete(searchKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchKey
    ]);
    return {
        inputRef: inputRef,
        recentList: recentList,
        suggestList: suggestList,
        autoList: autoList,
        searchKey: searchKey,
        rankList: rankList,
        state: state,
        tab: tab,
        setTab: setTab,
        setState: setState,
        clearCookies: clearCookies,
        setSearchKey: setSearchKey,
        handleEnter: handleEnter,
        deleteCookie: deleteCookie,
        handleLinkOpen: handleLinkOpen
    };
};
/* harmony default export */ var hooks_useGnbSearch = (useGnbSearch);

;// CONCATENATED MODULE: ./src/ui/Icons/RankDownIcon.tsx


function RankDownIcon(props) {
    var _boxSize, _boxSize1, _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "16",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 11L12.5 5H3.5L8 11Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
        })
    });
}
/* harmony default export */ var Icons_RankDownIcon = (RankDownIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RankNoneIcon.tsx


function RankNoneIcon(props) {
    var _boxSize, _boxSize1, _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "16",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            x: "5",
            y: "8",
            width: "6",
            height: "1",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
        })
    });
}
/* harmony default export */ var Icons_RankNoneIcon = (RankNoneIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RankUpIcon.tsx


function RankUpIcon(props) {
    var _boxSize, _boxSize1, _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "16",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 5L12.5 11H3.5L8 5Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
        })
    });
}
/* harmony default export */ var Icons_RankUpIcon = (RankUpIcon);

;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/ui/RankList.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  max-height: 236px;\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 50%;\n  height: 44px;\n  padding-left: 12px;\n  padding-right: 12px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 22px;\n  height: 14px;\n  text-align: center;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 16px;\n  height: 16px;\n  margin-right: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var RankList = function(param) {
    var rankList = param.rankList, handleLinkOpen = param.handleLinkOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: rankList.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankContainer, {
                onClick: function() {
                    return handleLinkOpen(item[0]);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Ranking, {
                        children: index + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankStateIcon, {
                        children: Number(item[1]) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RankNoneIcon, {
                            fill: styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600]
                        }) : Number(item[1]) < 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RankDownIcon, {
                            fill: styles/* theme.colors.accent_colors.blue.default */.rS.colors.accent_colors.blue["default"]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RankUpIcon, {
                            fill: styles/* theme.colors.accent_colors.red.default */.rS.colors.accent_colors.red["default"]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankTitle, {
                        children: item[0]
                    })
                ]
            }, item);
        })
    });
};
/* harmony default export */ var ui_RankList = (RankList);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RankList__Container",
    componentId: "sc-1121caa5-0"
})(_templateObject());
var RankContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RankList__RankContainer",
    componentId: "sc-1121caa5-1"
})(_templateObject1(), styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]);
var Ranking = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RankList__Ranking",
    componentId: "sc-1121caa5-2"
})(_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.button.md_b */.rS.typography.button.md_b);
var RankStateIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RankList__RankStateIcon",
    componentId: "sc-1121caa5-3"
})(_templateObject3());
var RankTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RankList__RankTitle",
    componentId: "sc-1121caa5-4"
})(_templateObject4(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2);

;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/ui/SuggestList.tsx
function SuggestList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SuggestList_templateObject() {
    var data = SuggestList_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-height: 416px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n"
    ]);
    SuggestList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestList_templateObject1() {
    var data = SuggestList_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0px 16px;\n  cursor: pointer;\n  color: ",
        ";\n  ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    SuggestList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SuggestList_templateObject2() {
    var data = SuggestList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n  width: 100%;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    SuggestList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var SuggestList = function(param) {
    var suggestList = param.suggestList, handleLinkOpen = param.handleLinkOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestList_Container, {
        children: suggestList.length !== 0 ? suggestList === null || suggestList === void 0 ? void 0 : suggestList.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                onClick: function() {
                    return handleLinkOpen(item);
                },
                children: item
            }, item);
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoneContent, {
            children: "추천 검색어가 없습니다."
        })
    });
};
/* harmony default export */ var ui_SuggestList = (SuggestList);
var SuggestList_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SuggestList__Container",
    componentId: "sc-27a329c3-0"
})(SuggestList_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SuggestList__Content",
    componentId: "sc-27a329c3-1"
})(SuggestList_templateObject1(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]);
var NoneContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SuggestList__NoneContent",
    componentId: "sc-27a329c3-2"
})(SuggestList_templateObject2(), styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600], styles/* theme.typography.body2 */.rS.typography.body2);

;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/ui/AutoComplete.tsx
function AutoComplete_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AutoComplete_templateObject() {
    var data = AutoComplete_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-height: 416px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n"
    ]);
    AutoComplete_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AutoComplete_templateObject1() {
    var data = AutoComplete_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0px 16px;\n  cursor: pointer;\n  color: ",
        ";\n\n  ",
        ";\n  > p {\n    color: ",
        ";\n  }\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    AutoComplete_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var AutoComplete = function(param) {
    var autoCompleteList = param.autoCompleteList, handleLinkOpen = param.handleLinkOpen, searchKey = param.searchKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoComplete_Container, {
        children: autoCompleteList === null || autoCompleteList === void 0 ? void 0 : autoCompleteList.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoComplete_Content, {
                onClick: function() {
                    return handleLinkOpen(item);
                },
                dangerouslySetInnerHTML: {
                    __html: item.replaceAll(searchKey, "<p>".concat(searchKey, "</p>"))
                }
            }, "autoComplete-".concat(item, "-").concat(index));
        })
    });
};
/* harmony default export */ var ui_AutoComplete = (AutoComplete);
var AutoComplete_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AutoComplete__Container",
    componentId: "sc-3dce03b3-0"
})(AutoComplete_templateObject());
var AutoComplete_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AutoComplete__Content",
    componentId: "sc-3dce03b3-1"
})(AutoComplete_templateObject1(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.accent_colors.red.default */.rS.colors.accent_colors.red["default"], styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]);

;// CONCATENATED MODULE: ./src/ui/Icons/Close16Icon.tsx


function Close16Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1347 4.35348C12.33 4.54874 12.33 4.86532 12.1347 5.06058L5.06366 12.1317C4.8684 12.3269 4.55181 12.3269 4.35655 12.1317C4.16129 11.9364 4.16129 11.6198 4.35655 11.4245L11.4276 4.35348C11.6229 4.15822 11.9395 4.15822 12.1347 4.35348Z",
                fill: props.fill || "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1307 12.1318C11.9354 12.3271 11.6188 12.3271 11.4235 12.1318L4.35248 5.06073C4.15722 4.86547 4.15722 4.54889 4.35248 4.35362C4.54774 4.15836 4.86432 4.15836 5.05959 4.35362L12.1307 11.4247C12.3259 11.62 12.3259 11.9365 12.1307 12.1318Z",
                fill: props.fill || "#121212"
            })
        ]
    });
}
/* harmony default export */ var Icons_Close16Icon = (Close16Icon);

;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/ui/RecentList.tsx
function RecentList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RecentList_templateObject() {
    var data = RecentList_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-height: 416px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n"
    ]);
    RecentList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecentList_templateObject1() {
    var data = RecentList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    RecentList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecentList_templateObject2() {
    var data = RecentList_taggedTemplateLiteral([
        "\n  width: calc(100% - 24px);\n  height: 40px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    RecentList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecentList_templateObject3() {
    var data = RecentList_taggedTemplateLiteral([
        "\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n"
    ]);
    RecentList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RecentList_templateObject4() {
    var data = RecentList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n  width: 100%;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    RecentList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var RecentList = function(param) {
    var recentList = param.recentList, handleLinkOpen = param.handleLinkOpen, deleteCookie = param.deleteCookie;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentList_Container, {
        children: recentList.length !== 0 ? recentList === null || recentList === void 0 ? void 0 : recentList.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContetnContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                        onClick: function() {
                            return handleLinkOpen(item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            width: "100%",
                            isNoWrap: true,
                            variant: "label_md_r",
                            color: "color_chip.primary",
                            noWrapTextOverflow: "ellipsis",
                            children: item
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentIcon, {
                        onClick: function(e) {
                            e.preventDefault();
                            deleteCookie(item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Close16Icon, {})
                    })
                ]
            }, item);
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentList_NoneContent, {
            children: "최근 검색어가 없습니다."
        })
    });
};
/* harmony default export */ var ui_RecentList = (RecentList);
var RecentList_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecentList__Container",
    componentId: "sc-929c387d-0"
})(RecentList_templateObject());
var ContetnContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecentList__ContetnContainer",
    componentId: "sc-929c387d-1"
})(RecentList_templateObject1(), styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]);
var ContentText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecentList__ContentText",
    componentId: "sc-929c387d-2"
})(RecentList_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2);
var ContentIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecentList__ContentIcon",
    componentId: "sc-929c387d-3"
})(RecentList_templateObject3());
var RecentList_NoneContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecentList__NoneContent",
    componentId: "sc-929c387d-4"
})(RecentList_templateObject4(), styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600], styles/* theme.typography.body2 */.rS.typography.body2);

;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/GnbSearchInput.tsx
function GnbSearchInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GnbSearchInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GnbSearchInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function GnbSearchInput_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function GnbSearchInput_templateObject() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 360px;\n  max-width: 360px;\n  width: 360px;\n"
    ]);
    GnbSearchInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GnbSearchInput_templateObject1() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 12px;\n"
    ]);
    GnbSearchInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GnbSearchInput_templateObject2() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    GnbSearchInput_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GnbSearchInput_templateObject3() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 358px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-height: 582px;\n  box-sizing: content-box;\n  background-color: ",
        ";\n  overflow: hidden;\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n"
    ]);
    GnbSearchInput_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GnbSearchInput_templateObject4() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 328px;\n  height: 46px;\n  border: none;\n  border-bottom: ",
        ";\n  padding: 1px 32px 0 0;\n  box-sizing: border-box;\n  color: ",
        ";\n  caret-color: ",
        ";\n\n  ::placeholder {\n    font-family: 'pretendard';\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 140%;\n    color: ",
        ";\n  }\n"
    ]);
    GnbSearchInput_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  width: 328px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  position: absolute;\n  cursor: pointer;\n  top: 9px;\n  right: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 328px;\n  align-items: center;\n\n  border-top: 1px solid ",
        ";\n  justify-content: space-between;\n  height: 56px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = GnbSearchInput_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}













var TAB_LIST = [
    {
        id: 0,
        name: "최근 검색어",
        type: "최근 검색어"
    },
    {
        id: 1,
        name: "추천 검색어",
        type: "추천 검색어"
    },
    {
        id: 2,
        name: "인기 검색어",
        type: "인기 검색어"
    }, 
];
var DEFAULT_ELEMENT = "input";
var GnbSearchInput = function(_param, ref) {
    var _width = _param.width, width = _width === void 0 ? 360 : _width, _height = _param.height, height = _height === void 0 ? 48 : _height, props = _objectWithoutProperties(_param, [
        "width",
        "height"
    ]);
    var _$ref = hooks_useGnbSearch(), inputRef = _$ref.inputRef, searchKey = _$ref.searchKey, rankList = _$ref.rankList, suggestList = _$ref.suggestList, autoList = _$ref.autoList, recentList = _$ref.recentList, state = _$ref.state, tab = _$ref.tab, setTab = _$ref.setTab, setState = _$ref.setState, setSearchKey = _$ref.setSearchKey, handleLinkOpen = _$ref.handleLinkOpen, handleEnter = _$ref.handleEnter, clearCookies = _$ref.clearCookies, deleteCookie = _$ref.deleteCookie;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GnbSearchInputContainer, {
        onSubmit: handleEnter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrap, {
            ref: inputRef,
            onClick: function() {
                return setState(true);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, GnbSearchInput_objectSpread({
                    ref: ref,
                    width: width,
                    focusState: state,
                    value: searchKey,
                    onChange: function(param) {
                        var target = param.target;
                        return setSearchKey(target.value);
                    },
                    maxLength: 100
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIconWrap, {
                    onClick: handleEnter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Search28Icon, {})
                }),
                state && !searchKey && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab3/* default */.Z, {
                                data: TAB_LIST,
                                height: "48px",
                                onClickHandler: function(e) {
                                    return setTab(e.type);
                                },
                                currentValue: tab
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBox, {
                            children: [
                                tab === "최근 검색어" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_RecentList, {
                                    recentList: recentList,
                                    handleLinkOpen: handleLinkOpen,
                                    deleteCookie: deleteCookie
                                }),
                                tab === "인기 검색어" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_RankList, {
                                    rankList: rankList,
                                    handleLinkOpen: handleLinkOpen
                                }),
                                tab === "추천 검색어" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SuggestList, {
                                    handleLinkOpen: handleLinkOpen,
                                    suggestList: suggestList
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropBoxFooter, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropBoxFooterLeft, {
                                    children: tab === "최근 검색어" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshBtn, {
                                        onClick: clearCookies,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, {
                                            type: "button",
                                            icon: {
                                                align: "right",
                                                variant: "ic_refresh"
                                            },
                                            size: "md",
                                            color: "color_chip.primary",
                                            children: "초기화"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropBoxFooterIcon, {
                                    boxSize: "32px",
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        setState(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Close32Icon, {})
                                })
                            ]
                        })
                    ]
                }),
                state && searchKey && autoList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropAutoBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AutoComplete, {
                            searchKey: searchKey,
                            autoCompleteList: autoList,
                            handleLinkOpen: handleLinkOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropBoxFooter, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropBoxFooterLeft, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropBoxFooterIcon, {
                                    boxSize: "32px",
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        setState(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Close32Icon, {})
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GnbSearchInput_GnbSearchInput = (/*#__PURE__*/(0,react.forwardRef)(GnbSearchInput));
var GnbSearchInputContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "GnbSearchInput__GnbSearchInputContainer",
    componentId: "sc-31d9a833-0"
})(GnbSearchInput_templateObject());
var DropBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__DropBox",
    componentId: "sc-31d9a833-1"
})(GnbSearchInput_templateObject1());
var DropAutoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__DropAutoBox",
    componentId: "sc-31d9a833-2"
})(GnbSearchInput_templateObject2());
var InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__InputWrap",
    componentId: "sc-31d9a833-3"
})(GnbSearchInput_templateObject3(), styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white, styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]);
var CustomInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "GnbSearchInput__CustomInput",
    componentId: "sc-31d9a833-4"
})(GnbSearchInput_templateObject4(), styles/* theme.typography.body1 */.rS.typography.body1, function(param) {
    var focusState = param.focusState;
    return focusState ? "1px solid ".concat(styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]) : "1px solid transparent";
}, styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.colors.accent_colors.red.default */.rS.colors.accent_colors.red["default"], styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600]);
var TabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__TabContainer",
    componentId: "sc-31d9a833-5"
})(_templateObject5());
var SearchIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__SearchIconWrap",
    componentId: "sc-31d9a833-6"
})(_templateObject6());
var ContentBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__ContentBox",
    componentId: "sc-31d9a833-7"
})(_templateObject7());
var DropBoxFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__DropBoxFooter",
    componentId: "sc-31d9a833-8"
})(_templateObject8(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"]);
var DropBoxFooterLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__DropBoxFooterLeft",
    componentId: "sc-31d9a833-9"
})(_templateObject9());
var DropBoxFooterIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__DropBoxFooterIcon",
    componentId: "sc-31d9a833-10"
})(_templateObject10(), function(param) {
    var boxSize = param.boxSize;
    return boxSize;
}, function(param) {
    var boxSize = param.boxSize;
    return boxSize;
});
var RefreshBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GnbSearchInput__RefreshBtn",
    componentId: "sc-31d9a833-11"
})(_templateObject11());

;// CONCATENATED MODULE: ./src/ui/GnbSearchInput/index.ts


;// CONCATENATED MODULE: ./src/ui/Header/hooks/useCategoryMenu.tsx

function useCategoryMenu(param) {
    var sectionMenuData = param.sectionMenuData;
    var ref = (0,react.useState)(""), enteredGroupCategoryNo = ref[0], setEnteredGroupCategoryNo = ref[1];
    var ref1 = (0,react.useState)(""), enteredMiddleCategoryNo = ref1[0], setEnteredMiddleCategoryNo = ref1[1];
    var handleEnteredGroupCategoryNo = (0,react.useCallback)(function(categoryNo) {
        setEnteredGroupCategoryNo(categoryNo);
    }, []);
    var handleEnteredMiddleCategoryNo = (0,react.useCallback)(function(categoryNo) {
        setEnteredMiddleCategoryNo(categoryNo);
    }, []);
    var enteredGroupCategory = (0,react.useMemo)(function() {
        if (sectionMenuData) {
            return sectionMenuData.groupCategoryList.find(function(item) {
                return item.categoryNo === enteredGroupCategoryNo;
            });
        } else return null;
    }, [
        enteredGroupCategoryNo,
        sectionMenuData
    ]);
    var enteredMiddleCategory = (0,react.useMemo)(function() {
        if (enteredGroupCategory === null || enteredGroupCategory === void 0 ? void 0 : enteredGroupCategory.middleCategoryList) {
            return enteredGroupCategory.middleCategoryList.find(function(item) {
                return item.categoryNo === enteredMiddleCategoryNo;
            });
        } else {
            return null;
        }
    }, [
        enteredGroupCategory === null || enteredGroupCategory === void 0 ? void 0 : enteredGroupCategory.middleCategoryList,
        enteredMiddleCategoryNo
    ]);
    return {
        handleEnteredGroupCategoryNo: handleEnteredGroupCategoryNo,
        enteredGroupCategoryNo: enteredGroupCategoryNo,
        handleEnteredMiddleCategoryNo: handleEnteredMiddleCategoryNo,
        enteredMiddleCategoryNo: enteredMiddleCategoryNo,
        enteredGroupCategory: enteredGroupCategory,
        enteredMiddleCategory: enteredMiddleCategory
    };
}
/* harmony default export */ var hooks_useCategoryMenu = (useCategoryMenu);

// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
;// CONCATENATED MODULE: ./src/ui/Header/CategoryMenu.tsx
function CategoryMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CategoryMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CategoryMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CategoryMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryMenu_templateObject() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 34px;\n  left: -77px;\n  display: ",
        ";\n"
    ]);
    CategoryMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject1() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  width: 216px;\n  height: 34px;\n  padding: 10px 24px;\n  }\n"
    ]);
    CategoryMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject2() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: block;\n  width: 216px;\n  height: 34px;\n  padding: 10px 24px;\n  }\n"
    ]);
    CategoryMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject3() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: block;\n  width: 216px;\n  height: 34px;\n  padding: 10px 24px;\n  &: hover {\n    & > div {\n      color: black;\n    }\n  }\n"
    ]);
    CategoryMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject4() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  padding: 8px 0px;\n"
    ]);
    CategoryMenu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject5() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 1px;\n"
    ]);
    CategoryMenu_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






function CategoryMenu(param) {
    var sectionMenuData = param.sectionMenuData, _isShow = param.isShow, isShow = _isShow === void 0 ? false : _isShow;
    var ref = hooks_useCategoryMenu({
        sectionMenuData: sectionMenuData
    }), handleEnteredGroupCategoryNo = ref.handleEnteredGroupCategoryNo, enteredGroupCategoryNo = ref.enteredGroupCategoryNo, handleEnteredMiddleCategoryNo = ref.handleEnteredMiddleCategoryNo, enteredMiddleCategoryNo = ref.enteredMiddleCategoryNo, enteredGroupCategory = ref.enteredGroupCategory, enteredMiddleCategory = ref.enteredMiddleCategory;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMenuWrap, {
        border: "1px solid",
        backgroundColor: "color_chip.white",
        isShow: isShow && (sectionMenuData === null || sectionMenuData === void 0 ? void 0 : sectionMenuData.groupCategoryList) !== undefined && (sectionMenuData === null || sectionMenuData === void 0 ? void 0 : sectionMenuData.groupCategoryList.length) > 0,
        onMouseLeave: function() {
            handleEnteredGroupCategoryNo("");
            handleEnteredMiddleCategoryNo("");
        },
        height: 531,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
            alignment: "start",
            height: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryListWrap, {
                    height: "100%",
                    overflowY: "auto",
                    children: [
                        sectionMenuData === null || sectionMenuData === void 0 ? void 0 : sectionMenuData.groupCategoryList.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupCategoryItemWrap, _objectSpreadProps(CategoryMenu_objectSpread({
                                onMouseEnter: function() {
                                    return handleEnteredGroupCategoryNo(item.categoryNo);
                                },
                                onClick: function() {
                                    return window.location.href = item.linkUrl || "/";
                                },
                                backgroundColor: enteredGroupCategoryNo === item.categoryNo ? "color_chip.primary" : "color_chip.white"
                            }, tracking/* default.tagGTM */.Z.tagGTM("mall_gnb_category_depth1_button", {
                                "menu-value": item.categoryName
                            })), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                    space: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: item.isHighLight === "Y" ? "label_md_b" : "label_md_m",
                                            // 쌤페스타 한정 강조 색상 노출 하드코딩 요청 건. 20511(홈퍼니싱), 20512(인테리어)
                                            color: item.categoryNo === "20511" || item.categoryNo === "20512" ? "#FC8300" : enteredGroupCategoryNo === item.categoryNo ? "color_chip.white" : "color_chip.primary",
                                            children: item.categoryName
                                        }),
                                        item.isHighLight === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBadge */.gl, {
                                            variant: "style1"
                                        })
                                    ]
                                })
                            }), "grpCtgList-key-".concat(index, "-").concat(item.categoryName));
                        }),
                        sectionMenuData === null || sectionMenuData === void 0 ? void 0 : sectionMenuData.menuList.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupCategoryItemWrap, _objectSpreadProps(CategoryMenu_objectSpread({
                                onMouseEnter: function() {
                                    return handleEnteredGroupCategoryNo(item.menuDataNm);
                                },
                                onClick: function() {
                                    var ref;
                                    return window.location.href = (item === null || item === void 0 ? void 0 : (ref = item.appLinkInfoDto) === null || ref === void 0 ? void 0 : ref.linkUrl) || "/";
                                },
                                backgroundColor: enteredGroupCategoryNo === item.menuDataNm ? "color_chip.primary" : "color_chip.white"
                            }, tracking/* default.tagGTM */.Z.tagGTM("mall_gnb_category_depth1_button", {
                                "menu-value": item.menuDataNm
                            })), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                    alignment: "start",
                                    space: 2,
                                    children: item.menuDataNm === "쌤페스타" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: item.isHighLight === "Y" ? "label_md_b" : "label_md_m",
                                                color: "#FC8300",
                                                children: "쌤페스타"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBadge */.gl, {
                                                variant: "style1"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: item.isHighLight === "Y" ? "label_md_b" : "label_md_m",
                                                color: enteredGroupCategoryNo === item.menuDataNm ? "color_chip.white" : "color_chip.primary",
                                                children: item.menuDataNm
                                            }),
                                            item.isHighLight === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                                                size: "sm"
                                            })
                                        ]
                                    })
                                })
                            }), "grpCtgList-key-".concat(index, "-").concat(item.menuDataNm));
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                    backgroundColor: "color_chip.gray.100"
                }),
                enteredGroupCategoryNo !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListWrap, {
                            height: "100%",
                            overflowY: "auto",
                            children: (enteredGroupCategory === null || enteredGroupCategory === void 0 ? void 0 : enteredGroupCategory.middleCategoryList) && enteredGroupCategory.middleCategoryList.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleCategoryItemWrap, _objectSpreadProps(CategoryMenu_objectSpread({
                                        onMouseEnter: function() {
                                            return handleEnteredMiddleCategoryNo(item.categoryNo);
                                        },
                                        onClick: function() {
                                            return window.location.href = item.linkUrl || "/";
                                        },
                                        backgroundColor: enteredMiddleCategoryNo === item.categoryNo ? "color_chip.gray.100" : "color_chip.white"
                                    }, tracking/* default.tagGTM */.Z.tagGTM("mall_gnb_category_depth2_button", {
                                        "menu-value": item.categoryName
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                            space: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "label_md_m",
                                                    color: enteredMiddleCategoryNo === item.categoryNo ? "color_chip.primary" : "color_chip.gray.700",
                                                    children: item.categoryName
                                                }),
                                                item.isHighLight === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBadge */.gl, {
                                                    variant: "style1"
                                                })
                                            ]
                                        })
                                    }), "category-menu-depth2-text-".concat(item.categoryNo, "-").concat(item.categoryName))
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                            backgroundColor: "color_chip.gray.100"
                        })
                    ]
                }),
                enteredMiddleCategoryNo !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListWrap, {
                            children: (enteredMiddleCategory === null || enteredMiddleCategory === void 0 ? void 0 : enteredMiddleCategory.smallCategoryList) && enteredMiddleCategory.smallCategoryList.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: index < 15 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallCategoryItemWrap, _objectSpreadProps(CategoryMenu_objectSpread({
                                        onClick: function() {
                                            return window.location.href = item.linkUrl || "/";
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("mall_gnb_category_depth3_button", {
                                        "menu-value": item.categoryName
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                            space: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "label_md_m",
                                                    color: "color_chip.gray.700",
                                                    children: item.categoryName
                                                }),
                                                item.isHighLight === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBadge */.gl, {
                                                    variant: "style1"
                                                })
                                            ]
                                        })
                                    }), "category-menu-depth3-".concat(item.categoryNo, "-").concat(item.categoryName))
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListWrap, {
                            children: (enteredMiddleCategory === null || enteredMiddleCategory === void 0 ? void 0 : enteredMiddleCategory.smallCategoryList) && enteredMiddleCategory.smallCategoryList.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: index >= 15 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallCategoryItemWrap, _objectSpreadProps(CategoryMenu_objectSpread({
                                        onClick: function() {
                                            return window.location.href = item.linkUrl || "/";
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("mall_gnb_category_depth3_button", {
                                        "menu-value": item.categoryName
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                            space: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "label_md_m",
                                                    color: "color_chip.gray.700",
                                                    children: item.categoryName
                                                }),
                                                item.isHighLight === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBadge */.gl, {
                                                    variant: "style1"
                                                })
                                            ]
                                        })
                                    }), "category-menu-depth3-".concat(item.categoryNo, "-").concat(item.categoryName))
                                });
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Header_CategoryMenu = (CategoryMenu);
var CategoryMenuWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "CategoryMenu__CategoryMenuWrap",
    componentId: "sc-22c6672b-0"
})(CategoryMenu_templateObject(), function(param) {
    var isShow = param.isShow;
    return isShow ? "flex" : "none";
});
var GroupCategoryItemWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "CategoryMenu__GroupCategoryItemWrap",
    componentId: "sc-22c6672b-1"
})(CategoryMenu_templateObject1());
var MiddleCategoryItemWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "CategoryMenu__MiddleCategoryItemWrap",
    componentId: "sc-22c6672b-2"
})(CategoryMenu_templateObject2());
var SmallCategoryItemWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "CategoryMenu__SmallCategoryItemWrap",
    componentId: "sc-22c6672b-3"
})(CategoryMenu_templateObject3());
var CategoryListWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "CategoryMenu__CategoryListWrap",
    componentId: "sc-22c6672b-4"
})(CategoryMenu_templateObject4());
var Divider = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "CategoryMenu__Divider",
    componentId: "sc-22c6672b-5"
})(CategoryMenu_templateObject5());

;// CONCATENATED MODULE: ./src/ui/Header/Header.tsx
function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Header_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Header_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Header_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Header_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Header_templateObject() {
    var data = Header_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = Header_taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  background-color: ",
        ";\n  position: sticky;\n  top: 0;\n  justify-content: space-between;\n  width: 100%;\n  transition: background-color 0.2s;\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: ",
        "px;\n  border-bottom: 1px solid;\n  border-color: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    var data = Header_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    Header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_templateObject4() {
    var data = Header_taggedTemplateLiteral([
        "\n  width: 437px;\n  visibility: ",
        ";\n"
    ]);
    Header_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_templateObject5() {
    var data = Header_taggedTemplateLiteral([
        "\n  cursor: pointer;\n\n  &:hover {\n    font-weight: 600;\n  }\n"
    ]);
    Header_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Header_templateObject6() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    Header_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Header_templateObject7() {
    var data = Header_taggedTemplateLiteral([
        ""
    ]);
    Header_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Header_templateObject8() {
    var data = Header_taggedTemplateLiteral([
        "\n  width: 42px;\n  height: 48px;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n"
    ]);
    Header_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Header_templateObject9() {
    var data = Header_taggedTemplateLiteral([
        "\n  visibility: ",
        ";\n"
    ]);
    Header_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Header_templateObject10() {
    var data = Header_taggedTemplateLiteral([
        "\n  height: ",
        "px;\n  position: absolute;\n"
    ]);
    Header_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}










var Header = function(param, ref) {
    var _isBackgroundColor = param.isBackgroundColor, isBackgroundColor = _isBackgroundColor === void 0 ? true : _isBackgroundColor, _isWelcomePage = param.isWelcomePage, isWelcomePage = _isWelcomePage === void 0 ? false : _isWelcomePage;
    var _$ref = hooks_useHeader({
        isBackgroundColor: isBackgroundColor,
        isWelcomePage: isWelcomePage
    }), handleRouter = _$ref.handleRouter, isAuthenticated = _$ref.isAuthenticated, isBackgroundColorActive = _$ref.isBackgroundColorActive, setIsHeaderMouseEnter = _$ref.setIsHeaderMouseEnter, mallSectionMenu = _$ref.mallSectionMenu, interiorSectionMenu = _$ref.interiorSectionMenu, isShowMallCategory = _$ref.isShowMallCategory, setIsShowMallCategory = _$ref.setIsShowMallCategory, isShowInteriorCategory = _$ref.isShowInteriorCategory, setIsShowInteriorCategory = _$ref.setIsShowInteriorCategory, isShowSearchInput = _$ref.isShowSearchInput, handleIsShowSearchInput = _$ref.handleIsShowSearchInput, enteredIcon = _$ref.enteredIcon, setEnteredIcon = _$ref.setEnteredIcon, cartCount = _$ref.cartCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FakeHeader, {
                ref: ref
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, Header_objectSpreadProps(Header_objectSpread({
                isBackgroundColorActive: isBackgroundColorActive,
                onMouseEnter: function() {
                    setIsHeaderMouseEnter(true);
                },
                onMouseLeave: function() {
                    setIsHeaderMouseEnter(false);
                }
            }, tracking/* default.tagGTM */.Z.tagGTM("header")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                    backgroundColor: isBackgroundColorActive ? "color_chip.white" : "transparent",
                    isWelcomePage: isWelcomePage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrap, {
                        alignment: "center",
                        space: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrap, {
                                space: 40,
                                alignment: "center",
                                height: "100%",
                                isWelcomePage: isWelcomePage,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLogo, Header_objectSpreadProps(Header_objectSpread({
                                        onClick: function() {
                                            return handleRouter(constants/* GNB_TYPE_VALUE.HOME */.CoW.HOME);
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("header_left_icon_button", {
                                        "menu-value": constants/* GNB_TYPE_VALUE.HOME.toLowerCase */.CoW.HOME.toLowerCase()
                                    })), {
                                        children: isWelcomePage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                            width: 231,
                                            height: 22
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc.CI, {
                                            variant: isBackgroundColorActive ? "CI_signature_black" : "CI_signature_white",
                                            resize: true,
                                            width: 231,
                                            height: 22
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 40,
                                        height: "100%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
                                                height: "100%",
                                                space: "center",
                                                onMouseEnter: function() {
                                                    return setIsShowMallCategory(true);
                                                },
                                                onMouseLeave: function() {
                                                    setIsShowMallCategory(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                                    position: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavText, Header_objectSpreadProps(Header_objectSpread({
                                                            onClick: function() {
                                                                return handleRouter(constants/* GNB_TYPE_VALUE.MALL */.CoW.MALL);
                                                            },
                                                            color: isBackgroundColorActive ? "color_chip.primary" : "color_chip.white",
                                                            variant: "label_xlg_m"
                                                        }, tracking/* default.tagGTM */.Z.tagGTM("header_left_icon_button", {
                                                            "menu-value": constants/* GNB_TYPE_VALUE.MALL.toLowerCase */.CoW.MALL.toLowerCase()
                                                        })), {
                                                            children: "홈퍼니싱"
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CategoryMenu, {
                                                            sectionMenuData: mallSectionMenu,
                                                            isShow: isShowMallCategory
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
                                                height: "100%",
                                                space: "center",
                                                onMouseEnter: function() {
                                                    return setIsShowInteriorCategory(true);
                                                },
                                                onMouseLeave: function() {
                                                    setIsShowInteriorCategory(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                                    position: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavText, Header_objectSpreadProps(Header_objectSpread({
                                                            onClick: function() {
                                                                return handleRouter(constants/* GNB_TYPE_VALUE.INTERIOR */.CoW.INTERIOR);
                                                            },
                                                            color: isBackgroundColorActive ? "color_chip.primary" : "color_chip.white",
                                                            variant: "label_xlg_m"
                                                        }, tracking/* default.tagGTM */.Z.tagGTM("header_left_icon_button", {
                                                            "menu-value": constants/* GNB_TYPE_VALUE.INTERIOR.toLowerCase */.CoW.INTERIOR.toLowerCase()
                                                        })), {
                                                            children: "인테리어"
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CategoryMenu, {
                                                            sectionMenuData: interiorSectionMenu,
                                                            isShow: isShowInteriorCategory
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                        position: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GnbSearchInput_GnbSearchInput, {
                                                placeholder: "검색어를 입력해 주세요.",
                                                isBackgroundColorActive: isBackgroundColorActive,
                                                isWelcomePage: isWelcomePage,
                                                isShowSearchInput: isShowSearchInput,
                                                handleIsShowSearchInput: handleIsShowSearchInput
                                            }),
                                            isWelcomePage && !isShowSearchInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextArea, {
                                                alignment: "center",
                                                mr: 24,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                    variant: "ic_search",
                                                    fillColor: isBackgroundColorActive ? "" : "white",
                                                    resize: true,
                                                    size: 28,
                                                    mb: 20,
                                                    onMouseEnter: function() {
                                                        handleIsShowSearchInput(true);
                                                    }
                                                })
                                            }, "SEARCH")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightIconArea, {
                                        space: 24,
                                        children: constants/* HEADER_MENU.filter */.kW_.filter(function(item) {
                                            return isAuthenticated ? item.key !== "LOGIN" : item.key !== "LOGOUT";
                                        }).map(function(_menuItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconTextArea, Header_objectSpreadProps(Header_objectSpread({
                                                alignment: "center",
                                                ml: index === 0 && !isWelcomePage ? 28 : 0,
                                                onMouseEnter: function() {
                                                    return setEnteredIcon(_menuItem.key);
                                                },
                                                onMouseLeave: function() {
                                                    return setEnteredIcon("");
                                                },
                                                onClick: function() {
                                                    return handleRouter(_menuItem.key);
                                                }
                                            }, tracking/* default.tagGTM */.Z.tagGTM("header_right_icon_button", {
                                                "menu-value": _menuItem.key.toLowerCase()
                                            })), {
                                                children: [
                                                    _menuItem.key === "LOGIN" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_login",
                                                        fillColor: isBackgroundColorActive ? "" : "white",
                                                        resize: true,
                                                        size: 28
                                                    }),
                                                    _menuItem.key === "LOGOUT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_logout",
                                                        fillColor: isBackgroundColorActive ? "" : "white",
                                                        resize: true,
                                                        size: 28
                                                    }),
                                                    _menuItem.key === "MY" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_my",
                                                        fillColor: isBackgroundColorActive ? "" : "white",
                                                        resize: true,
                                                        size: 28
                                                    }),
                                                    _menuItem.key === "SHOP_SEARCH" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_location",
                                                        fillColor: isBackgroundColorActive ? "" : "white",
                                                        resize: true,
                                                        size: 28
                                                    }),
                                                    _menuItem.key === "CART" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NumberBadge */.mA, {
                                                        count: cartCount,
                                                        offset: {
                                                            right: -7,
                                                            top: 10
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                            variant: "ic_shopping",
                                                            fillColor: isBackgroundColorActive ? "" : "white",
                                                            resize: true,
                                                            size: 28
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconText, {
                                                        variant: "label_sm_m",
                                                        color: isBackgroundColorActive ? "color_chip.primary" : "color_chip.white",
                                                        isShow: !isWelcomePage || _menuItem.key === enteredIcon,
                                                        children: _menuItem.value
                                                    })
                                                ]
                                            }), _menuItem.key);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }))
        ]
    });
};
/* harmony default export */ var Header_Header = (/*#__PURE__*/(0,react.forwardRef)(Header));
var HomeLogo = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Header__HomeLogo",
    componentId: "sc-6edc33d2-0"
})(Header_templateObject());
var HeaderWrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "Header__HeaderWrapper",
    componentId: "sc-6edc33d2-1"
})(Header_templateObject1(), styles/* HEADER_Z_INDEX */.bf, function(param) {
    var isBackgroundColorActive = param.isBackgroundColorActive;
    return isBackgroundColorActive ? "".concat(styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white) : "transparent";
});
var HeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Header__HeaderContainer",
    componentId: "sc-6edc33d2-2"
})(Header_templateObject2(), styles/* HEADER_HEIGHT */.Mz, function(param) {
    var isWelcomePage = param.isWelcomePage;
    var ref;
    return isWelcomePage ? "transparent" : "".concat((ref = styles/* theme */.rS === null || styles/* theme */.rS === void 0 ? void 0 : styles/* theme.colors.neutral_colors.gray */.rS.colors.neutral_colors.gray) === null || ref === void 0 ? void 0 : ref[100]);
}, styles/* HEADER_Z_INDEX */.bf);
var HeaderWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Header__HeaderWrap",
    componentId: "sc-6edc33d2-3"
})(Header_templateObject3(), styles/* LAYOUT_MAX_WIDTH */.N5, styles/* HEADER_HEIGHT */.Mz);
var LeftWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Header__LeftWrap",
    componentId: "sc-6edc33d2-4"
})(Header_templateObject4(), function(param) {
    var isWelcomePage = param.isWelcomePage;
    return isWelcomePage ? "hidden" : "visible";
});
var HeaderNavText = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "Header__HeaderNavText",
    componentId: "sc-6edc33d2-5"
})(Header_templateObject5());
var RightWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Header__RightWrap",
    componentId: "sc-6edc33d2-6"
})(Header_templateObject6());
var RightIconArea = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Header__RightIconArea",
    componentId: "sc-6edc33d2-7"
})(Header_templateObject7());
var IconTextArea = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "Header__IconTextArea",
    componentId: "sc-6edc33d2-8"
})(Header_templateObject8());
var IconText = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "Header__IconText",
    componentId: "sc-6edc33d2-9"
})(Header_templateObject9(), function(param) {
    var isShow = param.isShow;
    return isShow ? "visible" : "hidden";
});
var FakeHeader = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Header__FakeHeader",
    componentId: "sc-6edc33d2-10"
})(Header_templateObject10(), styles/* HEADER_HEIGHT */.Mz);

;// CONCATENATED MODULE: ./src/ui/Header/index.ts


;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/chatbot.ts
function chatbot_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function chatbot_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                chatbot_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                chatbot_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function chatbot_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetChatbotTokenGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetChatbotTokenGateway(httpClient) {
        chatbot_classCallCheck(this, GetChatbotTokenGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetChatbotTokenGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return chatbot_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/order-service/api/mall/v1/orders/chatbot/token")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetChatbotTokenGateway;
}();

;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/index.ts


;// CONCATENATED MODULE: ../../shared/order/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/order/src/index.ts



;// CONCATENATED MODULE: ./src/di-container/chatbot/gateway/client.ts


var ChatbotGateway = function() {
    return {
        getChatbotToken: new GetChatbotTokenGateway(axios/* axios */.o)
    };
};

;// CONCATENATED MODULE: ./src/components/Sendbird/Sendbird.tsx
function Sendbird_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Sendbird_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Sendbird_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Sendbird_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






var APP_ID = "67C2AAB3-4E0A-4371-B5A9-EBE121DA1530";
var AGENT_ID = "5c2837dd-f7eb-4cd4-b4c6-6f357fffe2d9";
var LOADER_URL = "https://aiagent.sendbird.com/orgs/default/index.js";
var CONTAINER_ID = "sendbird-messenger-container";
var Sendbird = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var messengerRef = (0,react.useRef)(null);
    var _$ref = (0,react.useState)(false), isInitialized = _$ref[0], setIsInitialized = _$ref[1];
    var _$ref1 = (0,react.useState)(false), isUpdateUserSession = _$ref1[0], setIsUpdateUserSession = _$ref1[1];
    var initializationRef = (0,react.useRef)(false);
    var getChatbotToken = ChatbotGateway().getChatbotToken;
    var authInfo = (0,useAuthenticated/* default */.Z)().authInfo;
    var toggleMessenger = (0,react.useCallback)(Sendbird_asyncToGenerator(runtime_default().mark(function _callee() {
        var _$ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!(messengerRef === null || messengerRef === void 0 ? void 0 : messengerRef.current) || !isInitialized)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    if (true) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 4:
                    _ctx.prev = 4;
                    if (isUpdateUserSession) {
                        _ctx.next = 13;
                        break;
                    }
                    ;
                    _ctx.next = 9;
                    return getChatbotToken.exec();
                case 9:
                    res = _ctx.sent;
                    _ctx.next = 12;
                    return window.__sendbird_messenger.updateUserSession({
                        userId: String(authInfo === null || authInfo === void 0 ? void 0 : authInfo.custNo),
                        authToken: res === null || res === void 0 ? void 0 : (_$ref = res.data) === null || _$ref === void 0 ? void 0 : _$ref.authToken
                    });
                case 12:
                    setIsUpdateUserSession(true);
                case 13:
                    _ctx.next = 15;
                    return window.__sendbird_messenger.open();
                case 15:
                    _ctx.next = 20;
                    break;
                case 17:
                    _ctx.prev = 17;
                    _ctx.t0 = _ctx["catch"](4);
                    console.error("Error toggling messenger:", _ctx.t0);
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                17
            ]
        ]);
    })), [
        authInfo === null || authInfo === void 0 ? void 0 : authInfo.custNo,
        getChatbotToken,
        isInitialized,
        isUpdateUserSession
    ]);
    var loadMessengerScript = (0,react.useCallback)(Sendbird_asyncToGenerator(runtime_default().mark(function _callee() {
        var existingScripts, script, initHandler, errorHandler;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    existingScripts = document.querySelectorAll("script[data-sendbird]");
                    existingScripts.forEach(function(script) {
                        return script.remove();
                    });
                    script = document.createElement("script");
                    script.setAttribute("data-sendbird", "true");
                    script.type = "module";
                    // 스크립트 내용 직접 작성
                    script.textContent = "\n        const init = async () => {\n          try {\n            // 이미 초기화되었다면 스킵\n            if (window.__sendbird_messenger) {\n              return;\n            }\n\n            // 스크립트를 동적으로 로드\n            const module = await import('".concat(LOADER_URL, "');\n\n            // 컨테이너 요소 확인\n            const container = document.getElementById('").concat(CONTAINER_ID, "');\n            if (!container) {\n              throw new Error('Container element not found');\n            }\n\n            \n            // loadMessenger 함수 찾기\n            const loadMessenger = module.loadMessenger || Object.values(module).find(\n              (value) => typeof value === 'function' && value.name === 'u'\n            );\n\n            if (!loadMessenger) {\n              throw new Error('loadMessenger function not found');\n            }\n\n            // 메신저 초기화\n            const messenger = await loadMessenger({ useShadowDOM: false });\n            await messenger.initialize({\n              appId: '").concat(APP_ID, "',\n              aiAgentId: '").concat(AGENT_ID, "',\n            });\n            \n            // 메신저 인스턴스 저장\n            window.__sendbird_messenger = messenger;\n            window.dispatchEvent(new Event('messengerInitialized'));\n\n          } catch (error) {\n            console.error('Messenger initialization error:', error);\n            window.dispatchEvent(new CustomEvent('messengerError', { detail: { message: error.message } }));\n          }\n        };\n\n        // DOM이 완전히 로드된 후 초기화 실행\n        if (document.readyState === 'complete') {\n          init();\n        } else {\n          window.addEventListener('load', init, { once: true });\n        }\n      ");
                    initHandler = function() {
                        if (initializationRef.current) return;
                        initializationRef.current = true;
                        messengerRef.current = window.__sendbird_messenger;
                        setIsInitialized(true);
                    };
                    errorHandler = function(event) {
                        var _$ref;
                        var errorEvent = event;
                        var errorMessage = ((_$ref = errorEvent.detail) === null || _$ref === void 0 ? void 0 : _$ref.message) || "Messenger initialization failed";
                        console.error("Messenger error:", errorMessage);
                    };
                    // 이벤트 리스너 등록
                    window.addEventListener("messengerInitialized", initHandler);
                    window.addEventListener("messengerError", errorHandler);
                    // 스크립트 추가
                    document.head.appendChild(script);
                    ;
                    return _ctx.abrupt("return", function() {
                        window.removeEventListener("messengerInitialized", initHandler);
                        window.removeEventListener("messengerError", errorHandler);
                    });
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Script loading error:", _ctx.t0);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                16
            ]
        ]);
    })), []);
    (0,react.useEffect)(function() {
        if (initializationRef === null || initializationRef === void 0 ? void 0 : initializationRef.current) return;
        loadMessengerScript();
        return function() {
            try {
                var existingScripts = document.querySelectorAll("script[data-sendbird]");
                existingScripts.forEach(function(script) {
                    return script.remove();
                });
                if (window.__sendbird_messenger) {
                    window.__sendbird_messenger = undefined;
                }
                initializationRef.current = false;
                setIsInitialized(false);
            } catch (e) {
                console.error("Error destroying messenger:", e);
            }
        };
    }, [
        loadMessengerScript
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        var observer = new MutationObserver(function() {
            var launcher = document.getElementById("sb-agent-launcher");
            if (launcher) {
                launcher.style.display = "none";
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return function() {
            return observer.disconnect();
        };
    }, []);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            toggleMessenger: toggleMessenger
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
        className: "App",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: CONTAINER_ID
        })
    });
});
Sendbird.displayName = "Sendbird";
/* harmony default export */ var Sendbird_Sendbird = (Sendbird);

;// CONCATENATED MODULE: ./src/components/Sendbird/index.tsx


// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/link.js
var next_link = __webpack_require__(49344);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/ui/Icons/ArrowUp16Icon.tsx


function ArrowUp16Icon(props) {
    var _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.77583 10.4244C2.54152 10.19 2.54152 9.81015 2.77583 9.57583L7.57583 4.77583C7.81015 4.54152 8.19005 4.54152 8.42436 4.77583L13.2244 9.57583C13.4587 9.81015 13.4587 10.19 13.2244 10.4244C12.99 10.6587 12.6101 10.6587 12.3758 10.4244L8.0001 6.04863L3.62436 10.4244C3.39005 10.6587 3.01015 10.6587 2.77583 10.4244Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
        })
    });
}
/* harmony default export */ var Icons_ArrowUp16Icon = (ArrowUp16Icon);

;// CONCATENATED MODULE: ./src/ui/Icons/ArrowDown16Icon.tsx


function ArrowDown16Icon(props) {
    var _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.2242 5.57564C13.4585 5.80995 13.4585 6.18985 13.2242 6.42417L8.42417 11.2242C8.18985 11.4585 7.80995 11.4585 7.57564 11.2242L2.77564 6.42417C2.54132 6.18985 2.54132 5.80995 2.77564 5.57564C3.00995 5.34132 3.38985 5.34132 3.62417 5.57564L7.9999 9.95137L12.3756 5.57564C12.61 5.34132 12.9899 5.34132 13.2242 5.57564Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#999999"
        })
    });
}
/* harmony default export */ var Icons_ArrowDown16Icon = (ArrowDown16Icon);

;// CONCATENATED MODULE: ./src/ui/Footer/ui/Top.tsx
function Top_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Top_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Top_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Top_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Top_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Top_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Top_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Top_templateObject() {
    var data = Top_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n  position: relative;\n  width: ",
        "px;\n  height: 56px;\n"
    ]);
    Top_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Top_templateObject1() {
    var data = Top_taggedTemplateLiteral([
        "\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 40px;\n"
    ]);
    Top_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Top_templateObject2() {
    var data = Top_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        "\n  &:nth-child(n+3):nth-child(-n+4) {\n    font-weight: 600;\n  }\n\n  cursor: pointer;\n"
    ]);
    Top_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Top_templateObject3() {
    var data = Top_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  width: 148px;\n  height: 28px;\n  border-radius: 2px;\n  position: absolute;\n  right: 0px;\n  top: 14px;\n  :hover {\n    background-color: ",
        ";\n    height: auto;\n  }\n"
    ]);
    Top_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Top_templateObject4() {
    var data = Top_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 16px;\n  padding-right: 12px;\n  cursor: pointer;\n"
    ]);
    Top_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Top_templateObject5() {
    var data = Top_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n  cursor: pointer;\n"
    ]);
    Top_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Top_templateObject6() {
    var data = Top_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 16px;\n  padding-right: 12px;\n  & + & {\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    Top_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Top_templateObject7() {
    var data = Top_taggedTemplateLiteral([
        "\n  height: 28px;\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n  cursor: pointer;\n"
    ]);
    Top_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









function Top(param) {
    var handleOpenPopup = param.handleOpenPopup, isHover = param.isHover, setIsHover = param.setIsHover, handleOpenLink = param.handleOpenLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuBar, Top_objectSpreadProps(Top_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("footer_menu")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                children: constants/* FOOTER_TOP_MENU_LIST.map */.Nhg.map(function(item) {
                    return item.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.link,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, Top_objectSpreadProps(Top_objectSpread({
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, tracking/* default.tagGTM */.Z.tagGTM("footer_menu_item_button", {
                            "menu-value": "".concat(item.value)
                        })), {
                            children: item.name
                        }))
                    }, "footer-menu-item-".concat(item.value)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, Top_objectSpreadProps(Top_objectSpread({
                        onClick: handleOpenPopup
                    }, tracking/* default.tagGTM */.Z.tagGTM("footer_menu_item_button", {
                        "menu-value": "".concat(item.value)
                    })), {
                        children: item.name
                    }), "footer-menu-item-".concat(item.value));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FamilySiteSelector, Top_objectSpreadProps(Top_objectSpread({
                onMouseOver: function() {
                    return setIsHover(true);
                },
                onMouseLeave: function() {
                    return setIsHover(false);
                }
            }, tracking/* default.tagGTM */.Z.tagGTM("footer_family_site_dropdown_button")), {
                children: !isHover ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Selected, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorTitle, {
                            children: "FAMILY SITE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowDown16Icon, {
                            fill: styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: constants/* FAMILY_SITE_LIST.map */.eiZ.map(function(item, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropItemWrap, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropItem, Top_objectSpreadProps(Top_objectSpread({
                                    onClick: function() {
                                        return handleOpenLink({
                                            url: item.link
                                        });
                                    }
                                }, tracking/* default.tagGTM */.Z.tagGTM("footer_family_site_button", {
                                    "option-value": "".concat(item.value)
                                })), {
                                    children: item.title
                                })),
                                idx === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowUp16Icon, {
                                    fill: styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary
                                })
                            ]
                        }, "family-site-".concat(item.id));
                    })
                })
            }))
        ]
    }));
}
var MenuBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Top__MenuBar",
    componentId: "sc-1b2eaf2d-0"
})(Top_templateObject(), styles/* LAYOUT_MAX_WIDTH */.N5);
var MenuList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "Top__MenuList",
    componentId: "sc-1b2eaf2d-1"
})(Top_templateObject1());
var Menu = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "Top__Menu",
    componentId: "sc-1b2eaf2d-2"
})(Top_templateObject2(), styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700], styles/* theme.typography.label.md_r */.rS.typography.label.md_r);
var FamilySiteSelector = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Top__FamilySiteSelector",
    componentId: "sc-1b2eaf2d-3"
})(Top_templateObject3(), styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white, styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200], styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white);
var Selected = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Top__Selected",
    componentId: "sc-1b2eaf2d-4"
})(Top_templateObject4());
var SelectorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Top__SelectorTitle",
    componentId: "sc-1b2eaf2d-5"
})(Top_templateObject5(), styles/* theme.colors.neutral_colors.gray.500 */.rS.colors.neutral_colors.gray[500], styles/* theme.typography.label.sm_r */.rS.typography.label.sm_r);
var DropItemWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Top__DropItemWrap",
    componentId: "sc-1b2eaf2d-6"
})(Top_templateObject6(), styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]);
var DropItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Top__DropItem",
    componentId: "sc-1b2eaf2d-7"
})(Top_templateObject7(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.label.sm_r */.rS.typography.label.sm_r, styles/* theme.colors.accent_colors.red.default */.rS.colors.accent_colors.red["default"]);
/* harmony default export */ var ui_Top = (Top);

;// CONCATENATED MODULE: ./src/ui/Icons/QRcodeIcon.tsx


function QRcodeIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "85",
        height: "85",
        viewBox: "0 0 85 85",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "85",
                height: "85",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_3740_4824",
                            transform: "scale(0.004)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_3740_4824",
                        width: "250",
                        height: "250",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Icons_QRcodeIcon = (QRcodeIcon);

// EXTERNAL MODULE: ./src/components/Divider/index.ts
var components_Divider = __webpack_require__(95578);
;// CONCATENATED MODULE: ./src/ui/Footer/ui/Center.tsx
function Center_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Center_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Center_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Center_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Center_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Center_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Center_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Center_templateObject() {
    var data = Center_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  padding: 20px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin: 0 auto;\n"
    ]);
    Center_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Center_templateObject1() {
    var data = Center_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 112px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    Center_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Center_templateObject2() {
    var data = Center_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 98px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n"
    ]);
    Center_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Center_templateObject3() {
    var data = Center_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    Center_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Center_templateObject4() {
    var data = Center_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 20px;\n"
    ]);
    Center_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Center_templateObject5() {
    var data = Center_taggedTemplateLiteral([
        "\n  width: 217px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: left;\n"
    ]);
    Center_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Center_templateObject6() {
    var data = Center_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Center_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Center_templateObject7() {
    var data = Center_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0px 6px;\n  height: 20px;\n  gap: 2px;\n  border-radius: 2px;\n  background-color: ",
        ";\n  border: none;\n"
    ]);
    Center_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Center_templateObject8() {
    var data = Center_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Center_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Center_templateObject9() {
    var data = Center_taggedTemplateLiteral([
        "\n  border: 1px solid;\n  border-color: ",
        ";\n  border-radius: 4px;\n  background-color: ",
        ";\n  padding: 4px 4px 5px 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n"
    ]);
    Center_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Center_templateObject10() {
    var data = Center_taggedTemplateLiteral([
        "\n  text-align: center;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Center_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Center_templateObject11() {
    var data = Center_taggedTemplateLiteral([
        "\n  height: 17px;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    Center_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}










function Center(param) {
    var handleOpenNewScreen = param.handleOpenNewScreen, handleOpenKakaoByMallCenter = param.handleOpenKakaoByMallCenter, handleOpenKakaoByASCenter = param.handleOpenKakaoByASCenter, handleOpenBusinessInfoPopup = param.handleOpenBusinessInfoPopup, handleMoveQuickConsult = param.handleMoveQuickConsult, handleMoveMallCenter = param.handleMoveMallCenter, handleMoveServiceCenter = param.handleMoveServiceCenter, isAuthenticate = param.isAuthenticate, handleClickSendbird = param.handleClickSendbird;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterWrap, Center_objectSpreadProps(Center_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("footer_content")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterTopWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        space: 48,
                        alignment: "start",
                        mt: "6px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                alignment: "start",
                                space: 8,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                        height: 32,
                                        alignment: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc.CI, {
                                            variant: "CI_signature_primary",
                                            resize: true,
                                            width: 189,
                                            height: 18
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "subTitle6",
                                                color: "color_chip.gray.700",
                                                children: "고객센터 이용안내"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                                children: "평일 09:00 - 18:00 , 토요일 09:00 - 13:00 (일요일,공휴일 휴무)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                space: 60,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                        alignment: "start",
                                        space: 16,
                                        mt: "1px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                                alignment: "start",
                                                space: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, Center_objectSpreadProps(Center_objectSpread({
                                                        size: "lg",
                                                        icon: {
                                                            variant: "ic_arrow_right",
                                                            align: "right"
                                                        },
                                                        onClick: handleMoveMallCenter
                                                    }, tracking/* default.tagGTM */.Z.tagGTM("footer_content_hanssem_mall_request_button")), {
                                                        children: "한샘몰 문의"
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                        space: 4,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                variant: "caption1",
                                                                color: "color_chip.gray.600",
                                                                children: "상품, 배송, 사이트 이용문의"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                                                variant: "caption1",
                                                                color: "color_chip.gray.600",
                                                                children: [
                                                                    "(",
                                                                    constants/* HANSSEM_MALL_CALL */.MVF,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, Center_objectSpreadProps(Center_objectSpread({
                                                emphasis: "low",
                                                icon: {
                                                    align: "left",
                                                    variant: "ic_kakao_solid"
                                                },
                                                size: "md",
                                                onClick: isAuthenticate ? handleClickSendbird : handleOpenKakaoByMallCenter
                                            }, tracking/* default.tagGTM */.Z.tagGTM("footer_content_hanssem_mall_request_kakao_button")), {
                                                children: "채팅 상담"
                                            }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                        alignment: "start",
                                        space: 16,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                                alignment: "start",
                                                space: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, Center_objectSpreadProps(Center_objectSpread({
                                                        size: "lg",
                                                        icon: {
                                                            variant: "ic_arrow_right",
                                                            align: "right"
                                                        },
                                                        onClick: handleMoveServiceCenter
                                                    }, tracking/* default.tagGTM */.Z.tagGTM("footer_content_as_center_button")), {
                                                        children: "A/S 문의"
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                        space: 4,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                variant: "caption1",
                                                                color: "color_chip.gray.600",
                                                                children: "A/S 신청 및 추가부품 문의"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                                                variant: "caption1",
                                                                color: "color_chip.gray.600",
                                                                children: [
                                                                    "(",
                                                                    constants/* AS_CENTER_CALL */.lq7,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, Center_objectSpreadProps(Center_objectSpread({
                                                emphasis: "low",
                                                icon: {
                                                    align: "left",
                                                    variant: "ic_kakao_solid"
                                                },
                                                size: "md",
                                                onClick: handleOpenKakaoByASCenter
                                            }, tracking/* default.tagGTM */.Z.tagGTM("footer_content_as_center_kakao_button")), {
                                                children: "채팅 상담"
                                            }))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QrCodeWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_QRcodeIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QrCodeText, {
                                children: "앱 다운 받기"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterBottomWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterBottomBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterBottomBoxInner, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                        children: "㈜한샘 대표자: 김유진"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                        style: {
                                            marginLeft: "-10px"
                                        },
                                        children: "경기도 안산시 성곡동 665"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider/* default */.Z, {
                                        w: "1px",
                                        h: "12px",
                                        bgColor: styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                        children: "사업자등록번호 : 133-81-22865"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                                        children: [
                                            "통신판매업신고 : 2010-경기안산-0512",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBtn, Center_objectSpreadProps(Center_objectSpread({
                                                onClick: handleOpenNewScreen
                                            }, tracking/* default.tagGTM */.Z.tagGTM("footer_bizinfo_button")), {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBtnText, {
                                                    children: "사업자정보확인"
                                                })
                                            }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider/* default */.Z, {
                                        w: "1px",
                                        h: "12px",
                                        bgColor: styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                        children: "개인정보보호 최고 책임자 : 전무권"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider/* default */.Z, {
                                        w: "1px",
                                        h: "12px",
                                        bgColor: styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                                        children: [
                                            "한샘 매장",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://company.hanssem.com/customer_support/location_way/shop.do",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBtn, Center_objectSpreadProps(Center_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("footer_location_button")), {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBtnText, {
                                                        target: "_blank",
                                                        children: "위치보기"
                                                    })
                                                }))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                                children: [
                                    "KEB하나은행 구매안전서비스(채무지급보증)",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBtn, Center_objectSpreadProps(Center_objectSpread({
                                        onClick: handleOpenBusinessInfoPopup
                                    }, tracking/* default.tagGTM */.Z.tagGTM("footer_service_confirmation_button")), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBtnText, {
                                            children: "서비스 가입사실 확인"
                                        })
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                children: "고객님은 안전거래를 위해 현금결제 시 저희 쇼핑몰에서 가입한 KEB하나은행으로 구매안전서비스(채무지급보증)를 이용하실 수 있습니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright, {
                        children: "(C) Hanssem Co., Ltd. All rights reserved."
                    })
                ]
            })
        ]
    }));
}
var CenterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__CenterWrap",
    componentId: "sc-6c9709f-0"
})(Center_templateObject(), styles/* LAYOUT_MAX_WIDTH */.N5);
var CenterTopWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__CenterTopWrap",
    componentId: "sc-6c9709f-1"
})(Center_templateObject1());
var CenterBottomWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__CenterBottomWrap",
    componentId: "sc-6c9709f-2"
})(Center_templateObject2());
var CenterBottomBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__CenterBottomBox",
    componentId: "sc-6c9709f-3"
})(Center_templateObject3());
var CenterBottomBoxInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__CenterBottomBoxInner",
    componentId: "sc-6c9709f-4"
})(Center_templateObject4());
var TitleBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__TitleBox",
    componentId: "sc-6c9709f-5"
})(Center_templateObject5());
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__Info",
    componentId: "sc-6c9709f-6"
})(Center_templateObject6(), styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600], styles/* theme.typography.caption1 */.rS.typography.caption1);
var InfoBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "Center__InfoBtn",
    componentId: "sc-6c9709f-7"
})(Center_templateObject7(), styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100]);
var InfoBtnText = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "Center__InfoBtnText",
    componentId: "sc-6c9709f-8"
})(Center_templateObject8(), styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600], styles/* theme.typography.button.sm_r */.rS.typography.button.sm_r);
var QrCodeWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__QrCodeWrap",
    componentId: "sc-6c9709f-9"
})(Center_templateObject9(), styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200], styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white);
var QrCodeText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__QrCodeText",
    componentId: "sc-6c9709f-10"
})(Center_templateObject10(), styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary, styles/* theme.typography.caption1 */.rS.typography.caption1);
var Copyright = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Center__Copyright",
    componentId: "sc-6c9709f-11"
})(Center_templateObject11(), styles/* theme.typography.caption1 */.rS.typography.caption1, styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600]);
/* harmony default export */ var ui_Center = (Center);

;// CONCATENATED MODULE: ./src/ui/Footer/ui/Bottom.tsx
function Bottom_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Bottom_templateObject() {
    var data = Bottom_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 49px;\n  background-color: ",
        ";\n"
    ]);
    Bottom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Bottom_templateObject1() {
    var data = Bottom_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  width: ",
        "px;\n  height: 100%;\n"
    ]);
    Bottom_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Bottom_templateObject2() {
    var data = Bottom_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Bottom_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function Bottom() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottmWrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrap, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bottom_Info, {
                children: "한샘몰 판매 상품 중 '입점브랜드상품'으로 명기된 상품의 경우, (주)한샘은 판매자가 아닌 통신판매중개자이므로 판매자로서의 책임을 부담하지 아니합니다. 해당 상품, 거래정보 및 거래에 대하여는 실제 판매자인 각 입점업체에게 책임이 있습니다."
            })
        })
    });
}
var BottmWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Bottom__BottmWrap",
    componentId: "sc-85267f3d-0"
})(Bottom_templateObject(), styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100]);
var InfoWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Bottom__InfoWrap",
    componentId: "sc-85267f3d-1"
})(Bottom_templateObject1(), styles/* LAYOUT_MAX_WIDTH */.N5);
var Bottom_Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Bottom__Info",
    componentId: "sc-85267f3d-2"
})(Bottom_templateObject2(), styles/* LAYOUT_MAX_WIDTH */.N5, styles/* theme.colors.neutral_colors.gray.500 */.rS.colors.neutral_colors.gray[500], styles/* theme.typography.caption1 */.rS.typography.caption1);
/* harmony default export */ var ui_Bottom = (Bottom);

// EXTERNAL MODULE: ./src/components/Divider/Divider.tsx
var Divider_Divider = __webpack_require__(73161);
;// CONCATENATED MODULE: ./src/ui/Footer/ui/BusinessInfoPopup.tsx
function BusinessInfoPopup_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BusinessInfoPopup_templateObject() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  padding: 0px 40px 40px 40px;\n"
    ]);
    BusinessInfoPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject1() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  overflow: auto;\n  max-height: 350px;\n"
    ]);
    BusinessInfoPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject2() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n  white-space: pre-wrap;\n  margin-bottom: 20px;\n"
    ]);
    BusinessInfoPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject3() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  border-collapse: collapse;\n  white-space: pre-wrap;\n  border-top: 1px solid ",
        " !important;\n  color: ",
        ";\n"
    ]);
    BusinessInfoPopup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject4() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    BusinessInfoPopup_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject5() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  align-self: ",
        ";\n  padding: 14px 20px;\n  color: ",
        ";\n  ",
        ";\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    BusinessInfoPopup_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject6() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        " !important;\n"
    ]);
    BusinessInfoPopup_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject7() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  padding: 14px 20px;\n  ",
        ";\n"
    ]);
    BusinessInfoPopup_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BusinessInfoPopup_templateObject8() {
    var data = BusinessInfoPopup_taggedTemplateLiteral([
        "\n  width: 156px;\n  padding: 14px 20px;\n  box-sizing: border-box;\n  text-align: left;\n  background-color: ",
        ";\n  ",
        ";\n"
    ]);
    BusinessInfoPopup_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var TABLE_DATA = [
    {
        id: 1,
        title: "서비스의 명칭",
        text: "채무지급보증서비스"
    },
    {
        id: 2,
        title: "채무지급 보증기관",
        text: "KEB하나은행"
    },
    {
        id: 3,
        title: "채무지급보증의 범위",
        text: "선불식 전자상거래에 있어 한샘몰이 상품 등의 공급의무를 불이행함으로써 발생하는 소비자 피해"
    },
    {
        id: 4,
        title: "서비스 제공 대상",
        text: "소비자께서 전자상거래시 구매의 안전을 위하여 채무지급보증서비스를 신청하신 경우. \n단, 다음의 경우에는 채무지급보증서비스를 이용할 수 없습니다.\n1) 여신전문금융업법 제2조 제3호의 규정에 따른 신용카드로 상품 등의 대금을 지급하는 거래\n2) 정보통신망에 의하여 전송되어 제 3자가 배송을 확인 할 수 없는 상품 등을 구매하는 거래\n3) 일정기간에 걸쳐 분할되어 공급되는 상품 등을 구매하는 거래\n4) 기타 공정거래위원회가 정하여 고시하는 거래"
    },
    {
        id: 5,
        title: "보증금 한도",
        text: "소비자께서 선불로 지급한 당해 상품의 대금 범위 내"
    },
    {
        id: 6,
        title: "보증금의 지급시기",
        text: "채무지급지급사유가 발생한 경우 지체 없이 지급. 단, 채무보증지급기관은 지급사유를 판단하기 위하여 소비자에게 손해사정과 관련된 재 서류 등을 요청하고 그에 대한 심사를 할 수 있습니다.보증서비스"
    }, 
];
var BusinessInfoPopup = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BusinessInfoPopup_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contents, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadText, {
                        children: "한샘몰은 소비자의 전자상거래 구매안전을 위하여 다음과 같이 채무지급보증서비스를 제공합니다.\n(* 법적 근거: 전자상거래 등에서의 소비자보호에 관한 법률 제 24조 등)\n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tbody, {
                        children: TABLE_DATA.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                                        children: item.text
                                    })
                                ]
                            }, item.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCententText, {
                        align: "center",
                        children: "2013년 05월 15일"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomCententText, {
                        align: "left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "채무지급보증기관"
                            }),
                            "상호: ㈜KEB하나은행 주소: 서울시 서초구 방배동 131",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문의사항:㈜KEB하나은행 방배동지점(전화번호: 02-586-1128 내선 151)"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_BusinessInfoPopup = (BusinessInfoPopup);
var BusinessInfoPopup_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BusinessInfoPopup__Container",
    componentId: "sc-6a2cd2bd-0"
})(BusinessInfoPopup_templateObject());
var Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BusinessInfoPopup__Contents",
    componentId: "sc-6a2cd2bd-1"
})(BusinessInfoPopup_templateObject1());
var HeadText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BusinessInfoPopup__HeadText",
    componentId: "sc-6a2cd2bd-2"
})(BusinessInfoPopup_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2);
var Tbody = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "BusinessInfoPopup__Tbody",
    componentId: "sc-6a2cd2bd-3"
})(BusinessInfoPopup_templateObject3(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"]);
var BottomContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BusinessInfoPopup__BottomContent",
    componentId: "sc-6a2cd2bd-4"
})(BusinessInfoPopup_templateObject4());
var BottomCententText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BusinessInfoPopup__BottomCententText",
    componentId: "sc-6a2cd2bd-5"
})(BusinessInfoPopup_templateObject5(), function(param) {
    var align = param.align;
    return align;
}, styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700], styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"]);
var Tr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    displayName: "BusinessInfoPopup__Tr",
    componentId: "sc-6a2cd2bd-6"
})(BusinessInfoPopup_templateObject6(), styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100]);
var Td = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    displayName: "BusinessInfoPopup__Td",
    componentId: "sc-6a2cd2bd-7"
})(BusinessInfoPopup_templateObject7(), styles/* theme.typography.body2 */.rS.typography.body2);
var Th = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    displayName: "BusinessInfoPopup__Th",
    componentId: "sc-6a2cd2bd-8"
})(BusinessInfoPopup_templateObject8(), styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50], styles/* theme.typography.headline7 */.rS.typography.headline7);

;// CONCATENATED MODULE: ./src/ui/Footer/ui/EmailPopup.tsx
function EmailPopup_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EmailPopup_templateObject() {
    var data = EmailPopup_taggedTemplateLiteral([
        "\n  padding: 0px 40px 40px 40px;\n  color: ",
        ";\n  ",
        ";\n  white-space: pre-wrap;\n"
    ]);
    EmailPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var EmailPopup = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmailPopup_Container, {
        children: [
            "한샘은 공식적으로 허가되지 않은 이메일 무단수집을 거부합니다.",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다."
        ]
    });
};
/* harmony default export */ var ui_EmailPopup = (EmailPopup);
var EmailPopup_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EmailPopup__Container",
    componentId: "sc-1a254ad1-0"
})(EmailPopup_templateObject(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2);

// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-7.1.1-55c6f31f52-b227d1f588.zip/node_modules/query-string/index.js
var query_string = __webpack_require__(46757);
// EXTERNAL MODULE: ./src/providers/PopupProvider/PopupProvider.tsx + 1 modules
var PopupProvider = __webpack_require__(42677);
;// CONCATENATED MODULE: ./src/ui/Footer/hooks/useFooter.tsx
/* provided dependency */ var process = __webpack_require__(98822);
function useFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useFooter_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










var useFooter = function() {
    var handleOpen = (0,PopupProvider/* usePopup */.B)().handleOpen;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var sendbirdRef = (0,react.useRef)(null);
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var handleClickSendbird = (0,react.useCallback)(function() {
        var ref;
        (ref = sendbirdRef.current) === null || ref === void 0 ? void 0 : ref.toggleMessenger();
    }, []);
    var handleOpenPopup = (0,react.useCallback)(function() {
        handleOpen({
            popupProps: {
                title: "이메일 무단수집 거부",
                popupSize: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_EmailPopup, {})
            }
        });
    }, [
        handleOpen
    ]);
    var handleOpenBusinessInfoPopup = (0,react.useCallback)(function() {
        handleOpen({
            popupProps: {
                title: "채무지급보증서비스 이용안내",
                popupSize: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BusinessInfoPopup, {})
            }
        });
    }, [
        handleOpen
    ]);
    var handleOpenNewScreen = (0,react.useCallback)(function() {
        if (!utils/* isClient */.C5) {
            return false;
        }
        window.open("https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1338122865&apv_perm_no=", "mypopup", "width=600,height=400");
    }, []);
    var handleOpenLink = (0,react.useCallback)(function(param) {
        var url = param.url, _target = param.target, target = _target === void 0 ? "_self" : _target;
        if (!utils/* isClient */.C5) {
            return false;
        }
        window.open(url, target);
    }, []);
    var handleOpenKakaoByMallCenter = (0,react.useCallback)(function() {
        if (!utils/* isClient */.C5) {
            return false;
        }
        window.open("https://chat.eumnet.com/api/kakao/chat_open?yid=@한샘온라인고객센터");
    }, []);
    var handleOpenKakaoByASCenter = (0,react.useCallback)(function() {
        if (!utils/* isClient */.C5) {
            return false;
        }
        window.open("https://chat.eumnet.com/api/kakao/chat_open?yid=@hswebas");
    }, []);
    var handleMoveMallCenter = (0,react.useCallback)(function() {
        router.push("https://mall.hanssem.com/csCenter/csMain.do");
    }, [
        router
    ]);
    var handleMoveServiceCenter = (0,react.useCallback)(function() {
        if (!utils/* isClient */.C5) {
            return false;
        }
        window.open("https://as.hanssem.com/main.as");
    }, []);
    var handleMoveQuickConsult = (0,react.useCallback)(useFooter_asyncToGenerator(runtime_default().mark(function _callee() {
        var channelObj, channelStringified;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    channelObj = {
                        channelType: "OPKG_05",
                        channelUrl: "".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST).concat(router.asPath)
                    };
                    channelStringified = query_string.stringify(channelObj);
                    router.push("/quick-consult/request?".concat(channelStringified));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        router
    ]);
    return {
        isAuthenticated: isAuthenticated,
        sendbirdRef: sendbirdRef,
        handleClickSendbird: handleClickSendbird,
        handleOpenPopup: handleOpenPopup,
        handleOpenNewScreen: handleOpenNewScreen,
        handleOpenBusinessInfoPopup: handleOpenBusinessInfoPopup,
        handleOpenKakaoByMallCenter: handleOpenKakaoByMallCenter,
        handleOpenKakaoByASCenter: handleOpenKakaoByASCenter,
        handleOpenLink: handleOpenLink,
        handleMoveQuickConsult: handleMoveQuickConsult,
        handleMoveMallCenter: handleMoveMallCenter,
        handleMoveServiceCenter: handleMoveServiceCenter,
        setIsHover: setIsHover,
        isHover: isHover
    };
};
/* harmony default export */ var hooks_useFooter = (useFooter);

;// CONCATENATED MODULE: ./src/ui/Footer/Footer.tsx
function Footer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Footer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Footer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Footer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Footer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Footer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Footer_templateObject() {
    var data = Footer_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: ",
        ";\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_templateObject1() {
    var data = Footer_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  background-color: ",
        ";\n"
    ]);
    Footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











function Footer() {
    var ref = hooks_useFooter(), isAuthenticated = ref.isAuthenticated, sendbirdRef = ref.sendbirdRef, handleClickSendbird = ref.handleClickSendbird, handleOpenPopup = ref.handleOpenPopup, handleOpenNewScreen = ref.handleOpenNewScreen, handleOpenKakaoByMallCenter = ref.handleOpenKakaoByMallCenter, handleOpenKakaoByASCenter = ref.handleOpenKakaoByASCenter, setIsHover = ref.setIsHover, handleOpenLink = ref.handleOpenLink, handleOpenBusinessInfoPopup = ref.handleOpenBusinessInfoPopup, handleMoveQuickConsult = ref.handleMoveQuickConsult, handleMoveMallCenter = ref.handleMoveMallCenter, handleMoveServiceCenter = ref.handleMoveServiceCenter, isHover = ref.isHover;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLayout, Footer_objectSpreadProps(Footer_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("footer")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Top, {
                            handleOpenPopup: handleOpenPopup,
                            setIsHover: setIsHover,
                            handleOpenLink: handleOpenLink,
                            isHover: isHover
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                            bgColor: styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100],
                            h: "1px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Center, {
                            handleOpenNewScreen: handleOpenNewScreen,
                            handleOpenKakaoByMallCenter: handleOpenKakaoByMallCenter,
                            handleOpenKakaoByASCenter: handleOpenKakaoByASCenter,
                            handleOpenBusinessInfoPopup: handleOpenBusinessInfoPopup,
                            handleMoveQuickConsult: handleMoveQuickConsult,
                            handleMoveMallCenter: handleMoveMallCenter,
                            handleMoveServiceCenter: handleMoveServiceCenter,
                            isAuthenticate: isAuthenticated,
                            handleClickSendbird: handleClickSendbird
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Bottom, {})
                    ]
                })
            })),
            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sendbird_Sendbird, {
                ref: sendbirdRef
            })
        ]
    });
}
var FooterLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Footer__FooterLayout",
    componentId: "sc-e47304f7-0"
})(Footer_templateObject(), styles/* FOOTER_FULL_HEIGHT */.cD);
var FooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Footer__FooterWrap",
    componentId: "sc-e47304f7-1"
})(Footer_templateObject1(), styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]);
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/ui/Footer/index.ts


;// CONCATENATED MODULE: ./src/components/AppLayout/AppLayout.tsx
function AppLayout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AppLayout_templateObject() {
    var data = AppLayout_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  margin-top: -",
        "px;\n"
    ]);
    AppLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AppLayout_templateObject1() {
    var data = AppLayout_taggedTemplateLiteral([
        "\n        padding-top: ",
        "px;\n      "
    ]);
    AppLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AppLayout_templateObject2() {
    var data = AppLayout_taggedTemplateLiteral([
        "\n        padding-top: ",
        "px;\n      "
    ]);
    AppLayout_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AppLayout_templateObject3() {
    var data = AppLayout_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    AppLayout_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AppLayout_templateObject4() {
    var data = AppLayout_taggedTemplateLiteral([
        "\n  min-height: calc(100vh - ",
        "px);\n  margin: 0 auto;\n  ",
        "\n"
    ]);
    AppLayout_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var AppLayout = function(param) {
    var content = param.content, _isHeaderExist = param.isHeaderExist, isHeaderExist = _isHeaderExist === void 0 ? true : _isHeaderExist, _isFooterExist = param.isFooterExist, isFooterExist = _isFooterExist === void 0 ? true : _isFooterExist, _isQuickExist = param.isQuickExist, isQuickExist = _isQuickExist === void 0 ? true : _isQuickExist, _isGnbExist = param.isGnbExist, isGnbExist = _isGnbExist === void 0 ? true : _isGnbExist, _layoutType = param.layoutType, layoutType = _layoutType === void 0 ? "default" : _layoutType, _quickSize = param.quickSize, quickSize = _quickSize === void 0 ? "m" : _quickSize, bottomSheet = param.bottomSheet, infoState = param.infoState, bottomSheetName = param.bottomSheetName, _isGnbArea = param.isGnbArea, isGnbArea = _isGnbArea === void 0 ? true : _isGnbArea, floatingArea = param.floatingArea;
    var ref = (0,useScrollIsShow/* default */.Z)(0.1), headerRef = ref.ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
        children: [
            isHeaderExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                ref: headerRef,
                isGnbExist: isGnbExist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout_ContentBox, {
                type: layoutType,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrap, {
                    isGnbArea: isGnbArea,
                    isGnbExist: isGnbExist,
                    children: content
                })
            }),
            isFooterExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {}),
            floatingArea
        ]
    });
};
/* harmony default export */ var AppLayout_AppLayout = (AppLayout);
var Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AppLayout__Layout",
    componentId: "sc-75bb7b4d-0"
})(AppLayout_templateObject(), styles/* HEADER_HEIGHT */.Mz);
var ContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AppLayout__ContentWrap",
    componentId: "sc-75bb7b4d-1"
})(AppLayout_templateObject3(), function(param) {
    var isGnbArea = param.isGnbArea, isGnbExist = param.isGnbExist;
    if (isGnbArea) {
        return (0,styled_components_browser_esm/* css */.iv)(AppLayout_templateObject1(), isGnbExist ? styles/* HEADER_HEIGHT */.Mz + 60 : styles/* HEADER_HEIGHT */.Mz);
    } else {
        return (0,styled_components_browser_esm/* css */.iv)(AppLayout_templateObject2(), styles/* HEADER_HEIGHT */.Mz);
    }
});
var AppLayout_ContentBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AppLayout__ContentBox",
    componentId: "sc-75bb7b4d-2"
})(AppLayout_templateObject4(), styles/* HEADER_HEIGHT */.Mz + styles/* GNB_HEIGHT */.I$, function(param) {
    var type = param.type;
    if (type === "full") {
        return "\n        width: 100%;\n      ";
    } else if (type === "default") {
        return "\n        width: ".concat(styles/* LAYOUT_MAX_WIDTH */.N5, "px;\n      ");
    } else if (type === "responsive") {
        return "\n        width: 100%;\n        max-width: ".concat(styles/* LAYOUT_OVER_WIDTH */.Li, "px;\n      ");
    }
});

;// CONCATENATED MODULE: ./src/components/AppLayout/index.tsx
/* 작성자 : 이현우 */ 



/***/ }),

/***/ 73161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10278);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  background-color: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Divider(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DividerWrap, _objectSpread({}, props));
}
var ref, ref1, ref2, ref3;
var DividerWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Divider__DividerWrap",
    componentId: "sc-ed441bd-0"
})(_templateObject(), function(param) {
    var w = param.w;
    return w !== null && w !== void 0 ? w : "100%";
}, function(param) {
    var h = param.h;
    return h !== null && h !== void 0 ? h : "2px";
}, function(param) {
    var bgColor = param.bgColor;
    return bgColor || _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.neutral_colors.primary */ .rS.colors.neutral_colors.primary;
}, function(param) {
    var my = param.my, mt = param.mt;
    return (ref = mt !== null && mt !== void 0 ? mt : my) !== null && ref !== void 0 ? ref : "0px";
}, function(param) {
    var my = param.my, mb = param.mb;
    return (ref1 = mb !== null && mb !== void 0 ? mb : my) !== null && ref1 !== void 0 ? ref1 : "0px";
}, function(param) {
    var mx = param.mx, ml = param.ml;
    return (ref2 = ml !== null && ml !== void 0 ? ml : mx) !== null && ref2 !== void 0 ? ref2 : "0px";
}, function(param) {
    var mx = param.mx, mr = param.mr;
    return (ref3 = mr !== null && mr !== void 0 ? mr : mx) !== null && ref3 !== void 0 ? ref3 : "0px";
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 95578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Divider__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Divider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73161);



/***/ }),

/***/ 91964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ scrapGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61462);


var scrapGateway = function() {
    return {
        getScraps: new _remodeling_common__WEBPACK_IMPORTED_MODULE_1__/* .GetScrapsGateway */ .g(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getScrapCategories: new _remodeling_common__WEBPACK_IMPORTED_MODULE_1__/* .GetScrapCategoriesGateway */ .Z7(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        createScraps: new _remodeling_common__WEBPACK_IMPORTED_MODULE_1__/* .CreateScrapGateway */ .rx(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        deleteScraps: new _remodeling_common__WEBPACK_IMPORTED_MODULE_1__/* .DeleteScrapGateway */ .dW(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getCount: new _remodeling_common__WEBPACK_IMPORTED_MODULE_1__/* .GetScrapsCountGateway */ .nT(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 4986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ displayGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20378);


var displayGateway = function() {
    return {
        getMenus: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetMenusGateway */ .jS(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getGnb: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetGnbListGateway */ .cO(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getHamburgerMenus: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetHamburgerMenusGateway */ .no(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getDisplayInfo: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetDisplayInfoGateway */ .Jk(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getTemplateInfo: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetTemplateInfoGateway */ .PC(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getComponentData: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetComponentDataGateway */ .H_(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getComponentList: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetComponentListGateway */ .KR(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 24945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ goodsGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20378);
/* harmony import */ var _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24721);



var goodsGateway = function() {
    return {
        getCascade: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetGoodsCategoryGateway */ .Pw(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getGoodsDisplayOption: new _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__/* .GetGoodsDisplayOption */ .Qe(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 93951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VP": function() { return /* reexport */ hooks_useClipboard; },
  "t$": function() { return /* reexport */ hooks_useOnClickOutside; },
  "j8": function() { return /* reexport */ useScrap; },
  "y3": function() { return /* reexport */ hooks_useWindowScrollDirection; }
});

// UNUSED EXPORTS: useGnb, useGoodsCategory, useScrollIsShow

// EXTERNAL MODULE: ./src/hooks/useGnb.tsx
var useGnb = __webpack_require__(70914);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(98749);
// EXTERNAL MODULE: ./src/di-container/goods/gateway/client.ts
var client = __webpack_require__(24945);
;// CONCATENATED MODULE: ./src/hooks/useGoodsCategory.tsx



var useGoodsCategory = function() {
    var getCascade = goodsGateway().getCascade;
    var fetcher = function(req) {
        return getCascade.exec({
            typeValue: "PC"
        });
    };
    var ref = useSWR({}, fetcher), apiResponseData = ref.data;
    var goodsCategoryList = useMemo(function() {
        var ref;
        return (apiResponseData === null || apiResponseData === void 0 ? void 0 : apiResponseData.code) === 200 ? (apiResponseData === null || apiResponseData === void 0 ? void 0 : (ref = apiResponseData.data) === null || ref === void 0 ? void 0 : ref.categoryList) || [] : undefined;
    }, [
        apiResponseData
    ]);
    return {
        goodsCategoryList: goodsCategoryList
    };
};
/* harmony default export */ var hooks_useGoodsCategory = ((/* unused pure expression or super */ null && (useGoodsCategory)));

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-use-virtual-d51b87fa0c/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useCopyToClipboard.js + 2 modules
var useCopyToClipboard = __webpack_require__(75117);
;// CONCATENATED MODULE: ./src/hooks/useClipboard.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var useClipboard = function() {
    var ref = _slicedToArray((0,useCopyToClipboard/* default */.Z)(), 2), error = ref[0].error, copyToClipboard = ref[1];
    var handleCopy = (0,react.useCallback)(function(text) {
        copyToClipboard(text);
        return error;
    }, [
        copyToClipboard,
        error
    ]);
    return {
        handleCopy: handleCopy
    };
};
/* harmony default export */ var hooks_useClipboard = (useClipboard);

;// CONCATENATED MODULE: ./src/hooks/useOnClickOutside.ts

function useOnClickOutside(ref, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            if (!ref) return;
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
}
/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);

;// CONCATENATED MODULE: ./src/hooks/useWindowScrollDirection.ts

/**
 * @author 이현우
 * window scroll 시 위아래 방향 구하는 Hook
 */ var useWindowScrollDirection = function() {
    var prevY = (0,react.useRef)();
    var ref = (0,react.useState)(null), direction = ref[0], setDirection = ref[1];
    var ref1 = (0,react.useState)(null), y = ref1[0], setY = ref1[1];
    var handleChangeScrollListener = (0,react.useCallback)(function() {
        if (prevY.current != null) {
            if (prevY.current > scrollY) {
                setDirection("UP");
            } else if (prevY.current < scrollY) {
                setDirection("DOWN");
            } else {
                setDirection(null);
            }
        }
        prevY.current = scrollY;
        setY(scrollY);
    }, [
        setDirection
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleChangeScrollListener);
        return function() {
            return window.removeEventListener("scroll", handleChangeScrollListener);
        };
    }, [
        handleChangeScrollListener
    ]);
    return {
        direction: direction,
        y: y
    };
};
/* harmony default export */ var hooks_useWindowScrollDirection = (useWindowScrollDirection);

// EXTERNAL MODULE: ./src/hooks/useScrollIsShow.ts
var useScrollIsShow = __webpack_require__(76994);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-redux-virtual-d8cdb1e912/0/cache/react-redux-npm-8.0.4-ee216b0e53-fd940de6a6.zip/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(65703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-0bfff5899a/0/cache/@design-system-pc-npm-4.5.5-5209ca23ee-508cb735dc.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(56341);
// EXTERNAL MODULE: ./src/di-container/auth/gateway/client.ts
var gateway_client = __webpack_require__(2885);
// EXTERNAL MODULE: ./src/di-container/common/scrap/gateway/client.ts
var scrap_gateway_client = __webpack_require__(91964);
// EXTERNAL MODULE: ./src/hooks/useAuthenticated.ts
var useAuthenticated = __webpack_require__(90457);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
;// CONCATENATED MODULE: ./src/hooks/useScrap.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










var useConstructionCaseItem = function(param) {
    var id = param.id, name = param.name, landingUrl = param.landingUrl, imageUrl = param.imageUrl, scrapTypeCode = param.scrapTypeCode, scrapYn = param.scrapYn;
    var store = (0,es/* useStore */.oR)();
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var ref = (0,scrap_gateway_client/* scrapGateway */.N)(), createScraps = ref.createScraps, deleteScraps = ref.deleteScraps;
    var loginGateway = (0,gateway_client/* authGateway */.h)(store.dispatch).loginGateway;
    var toast = (0,design_system_pc/* useToast */.pm)().toast;
    var ref1 = (0,design_system_pc/* useAlert */.VY)(), handleAlertOpen = ref1.handleOpen;
    var ref2 = (0,design_system_pc/* useConfirm */.N4)(), handleConfirmOpen = ref2.handleOpen;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(scrapYn), isScrap = ref3[0], setIsScrap = ref3[1];
    var hasScrap = (0,react.useMemo)(function() {
        return isScrap === "Y";
    }, [
        isScrap
    ]);
    var handleLogin = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return loginGateway.exec();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        loginGateway
    ]);
    var handleDeleteScraps = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, code, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return deleteScraps.exec({
                        scrapTypeCode: scrapTypeCode,
                        targetId: id
                    });
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    message = ref.message;
                    if (!(code !== 200 && message)) {
                        _ctx.next = 8;
                        break;
                    }
                    handleAlertOpen({
                        content: message,
                        zIndex: styles/* ALERT_Z_INDEX */.iO
                    });
                    return _ctx.abrupt("return", "Y");
                case 8:
                    return _ctx.abrupt("return", "N");
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        deleteScraps,
        handleAlertOpen,
        id,
        scrapTypeCode
    ]);
    var handleCreateScraps = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, code, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return createScraps.exec({
                        scrapTypeCode: scrapTypeCode,
                        target: {
                            id: id,
                            name: name,
                            landingUrl: landingUrl,
                            imageUrl: imageUrl
                        }
                    });
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    message = ref.message;
                    if (!(code !== 200 && message)) {
                        _ctx.next = 8;
                        break;
                    }
                    handleAlertOpen({
                        content: message,
                        zIndex: styles/* ALERT_Z_INDEX */.iO
                    });
                    return _ctx.abrupt("return", "N");
                case 8:
                    return _ctx.abrupt("return", "Y");
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        createScraps,
        handleAlertOpen,
        id,
        imageUrl,
        landingUrl,
        name,
        scrapTypeCode, 
    ]);
    var handleGoScrap = (0,react.useCallback)(function() {
        router.push("".concat("https://mall.hanssem.com", "/mypage/wishList.do"));
    }, [
        router
    ]);
    var handleScrap = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var scrapResult, scrapResult1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isAuthenticated) {
                        _ctx.next = 3;
                        break;
                    }
                    handleConfirmOpen({
                        content: "로그인 후 이용 가능합니다. \n 로그인 하시겠습니까?",
                        cancelText: "취소",
                        confirmText: "확인",
                        handleConfirm: function() {
                            handleLogin();
                        }
                    });
                    return _ctx.abrupt("return");
                case 3:
                    ;
                    if (!hasScrap) {
                        _ctx.next = 12;
                        break;
                    }
                    setIsScrap("N");
                    _ctx.next = 8;
                    return handleDeleteScraps();
                case 8:
                    scrapResult = _ctx.sent;
                    setIsScrap(scrapResult);
                    _ctx.next = 18;
                    break;
                case 12:
                    setIsScrap("Y");
                    _ctx.next = 15;
                    return handleCreateScraps();
                case 15:
                    scrapResult1 = _ctx.sent;
                    setIsScrap(scrapResult1);
                    if (scrapResult1 === "Y") {
                        toast.success("찜 목록에 추가하였습니다.", {
                            placement: "bottom",
                            variant: "button",
                            actionButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, {
                                size: "lg",
                                isUnderline: true,
                                color: "color_chip.white",
                                onClick: handleGoScrap,
                                width: 74,
                                children: "찜 목록가기"
                            }),
                            offset: 87,
                            zIndex: styles/* TOAST_Z_INDEX */.kb
                        });
                    }
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isAuthenticated,
        hasScrap,
        handleConfirmOpen,
        handleLogin,
        handleDeleteScraps,
        handleCreateScraps,
        toast,
        handleGoScrap, 
    ]);
    (0,react.useEffect)(function() {
        setIsScrap(scrapYn);
    }, [
        scrapYn
    ]);
    return {
        hasScrap: hasScrap,
        handleScrap: handleScrap
    };
};
/* harmony default export */ var useScrap = (useConstructionCaseItem);

;// CONCATENATED MODULE: ./src/hooks/index.tsx









/***/ }),

/***/ 70914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98749);
/* harmony import */ var _di_container_display_gateway_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4986);



var useGnb = function(param) {
    var viewType = param.viewType, typeValue = param.typeValue;
    var ref = (0,_di_container_display_gateway_client__WEBPACK_IMPORTED_MODULE_2__/* .displayGateway */ .Q)(), getGnb = ref.getGnb, getMenus = ref.getMenus;
    var fetcher = function(req) {
        return getGnb.exec(req);
    };
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        gateway: "gnb",
        viewType: viewType,
        typeValue: typeValue
    }, fetcher), apiResponseData = ref1.data;
    var gnbList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (apiResponseData === null || apiResponseData === void 0 ? void 0 : apiResponseData.code) === 200 ? (apiResponseData === null || apiResponseData === void 0 ? void 0 : apiResponseData.data) || [] : undefined;
    }, [
        apiResponseData
    ]);
    var menuFetcher = function(req) {
        return getMenus.exec(req);
    };
    var ref2 = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        gateway: "menus",
        viewType: viewType,
        typeValue: typeValue
    }, menuFetcher), menusApiResponseData = ref2.data;
    var menuGrpList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref;
        return (menusApiResponseData === null || menusApiResponseData === void 0 ? void 0 : menusApiResponseData.code) === 200 ? (menusApiResponseData === null || menusApiResponseData === void 0 ? void 0 : (ref = menusApiResponseData.data) === null || ref === void 0 ? void 0 : ref.menuGrpList) || [] : undefined;
    }, [
        menusApiResponseData
    ]);
    return {
        gnbList: gnbList,
        menuGrpList: menuGrpList
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGnb);


/***/ }),

/***/ 76994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

/**
 *
 * @param threshold 뷰포트에 타겟 엘리먼트가 얼마나 보였을 때 동작할 지(0 ~ 1)
 
 */ var useScrollIsShow = function(threshold, cb) {
    var dom = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShow = ref[0], setIsShow = ref[1];
    var handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var _param = _slicedToArray(param, 1), entry = _param[0];
        if (entry.isIntersecting) {
            setIsShow(true);
            cb && cb();
        } else {
            setIsShow(false);
        }
    }, [
        cb
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer;
        var current = dom.current;
        if (current) {
            observer = new IntersectionObserver(handleScroll, {
                threshold: threshold
            });
            observer.observe(current);
            return function() {
                return observer && observer.disconnect();
            };
        }
    }, [
        handleScroll,
        threshold,
        dom
    ]);
    return {
        ref: dom,
        isShow: isShow
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useScrollIsShow);


/***/ }),

/***/ 5442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Tab3_Tab3; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/ui/hooks/useMenu.ts

function useMenu() {
    var ref = (0,react.useState)(0), activeId = ref[0], setActiveId = ref[1];
    var ref1 = (0,react.useState)(0), activeChipId = ref1[0], setActiveChipId = ref1[1];
    var handleActiveId = function(tabId) {
        setActiveId(tabId);
        setActiveChipId(0);
    };
    var handleActiveChipId = function(chipId) {
        setActiveChipId(chipId);
    };
    return {
        activeId: activeId,
        handleActiveId: handleActiveId,
        activeChipId: activeChipId,
        handleActiveChipId: handleActiveChipId
    };
}
/* harmony default export */ var hooks_useMenu = (useMenu);

;// CONCATENATED MODULE: ./src/ui/Tab3/Tab3.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: ",
        ";\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          border-top: 2px solid transparent;\n          border-bottom: 2px solid ",
        ";\n          ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          border-top: 1px solid transparent;\n          border-bottom: 1px solid ",
        ";\n          ",
        "\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  background-color: ",
        ";\n  color: ",
        ";\n  width: 100%;\n  height: 100%;\n  ",
        ";\n  &:first-child {\n    border-bottom-left-radius: 2px;\n  }\n  &:last-child {\n    border-bottom-right-radius: 2px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






function Tab3(param) {
    var data = param.data, onClickHandler = param.onClickHandler, currentValue = param.currentValue, height = param.height, _gtmName = param.gtmName, gtmName = _gtmName === void 0 ? "" : _gtmName;
    var ref = hooks_useMenu(), activeId = ref.activeId, handleActiveId = ref.handleActiveId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabWrap, _objectSpreadProps(_objectSpread({
        height: height
    }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName))), {
        children: data.map(function(tab, idx) {
            var isActive = activeId === tab.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, _objectSpreadProps(_objectSpread({
                isActive: currentValue ? tab.name === currentValue : isActive,
                onClick: function(e) {
                    e.preventDefault();
                    onClickHandler ? onClickHandler(tab, idx) : handleActiveId(tab.id);
                }
            }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName, "_button"), {
                "tab-value": tab.name
            })), {
                children: tab.text || tab.name
            }), "tab_3_".concat(idx, "_").concat(tab.id));
        })
    }));
}
var TabWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tab3__TabWrap",
    componentId: "sc-3afe431c-0"
})(_templateObject(), function(param) {
    var height = param.height;
    return height || "64px";
});
var TabButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "Tab3__TabButton",
    componentId: "sc-3afe431c-1"
})(_templateObject3(), styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white, styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary, function(param) {
    var isActive = param.isActive;
    return isActive ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary, styles/* theme.typography.button.lg_m */.rS.typography.button.lg_m) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100], styles/* theme.typography.button.lg_r */.rS.typography.button.lg_r);
});
/* harmony default export */ var Tab3_Tab3 = (Tab3);

;// CONCATENATED MODULE: ./src/ui/Tab3/index.ts



/***/ }),

/***/ 61462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rx": function() { return /* reexport */ CreateScrapGateway; },
  "dW": function() { return /* reexport */ DeleteScrapGateway; },
  "rd": function() { return /* reexport */ GetCartCountGateway; },
  "xy": function() { return /* reexport */ GetCertificationGateway; },
  "Z7": function() { return /* reexport */ GetScrapCategoriesGateway; },
  "nT": function() { return /* reexport */ GetScrapsCountGateway; },
  "g": function() { return /* reexport */ GetScrapsGateway; },
  "CH": function() { return /* reexport */ GetSearchAddressGateway; },
  "p9": function() { return /* reexport */ GetSearchBlueprintsGateway; },
  "Mr": function() { return /* reexport */ GetXSearchAutoCompleteGateway; },
  "z7": function() { return /* reexport */ GetXSearchRankingGateway; },
  "An": function() { return /* reexport */ GetXSearchSuggestGateway; },
  "$T": function() { return /* reexport */ PostCertificationGateway; },
  "t0": function() { return /* reexport */ UploadImagesGateway; }
});

// UNUSED EXPORTS: GetNoticesGateway

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-8.1.0-e74248e410-16fe49ab71.zip/node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(52778);
;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/cart.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


var GetCartCountGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetCartCountGateway(httpClient) {
        _classCallCheck(this, GetCartCountGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetCartCountGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string/* default.stringify */.Z.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/cart/count?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetCartCountGateway;
}();

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/search-address.ts
function search_address_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function search_address_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                search_address_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                search_address_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function search_address_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetSearchAddressGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetSearchAddressGateway(httpClient) {
        search_address_classCallCheck(this, GetSearchAddressGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSearchAddressGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return search_address_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/search/address"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSearchAddressGateway;
}();
var GetSearchBlueprintsGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetSearchBlueprintsGateway(httpClient) {
        search_address_classCallCheck(this, GetSearchBlueprintsGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSearchBlueprintsGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return search_address_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/search/blueprints"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSearchBlueprintsGateway;
}();

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/scrap.ts
function scrap_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function scrap_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                scrap_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                scrap_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function scrap_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetScrapsGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetScrapsGateway(httpClient) {
        scrap_classCallCheck(this, GetScrapsGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetScrapsGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return scrap_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/scraps"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetScrapsGateway;
}();
var GetScrapCategoriesGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetScrapCategoriesGateway(httpClient) {
        scrap_classCallCheck(this, GetScrapCategoriesGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetScrapCategoriesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return scrap_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/scraps/categories"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetScrapCategoriesGateway;
}();
var CreateScrapGateway = /*#__PURE__*/ function() {
    "use strict";
    function CreateScrapGateway(httpClient) {
        scrap_classCallCheck(this, CreateScrapGateway);
        this.httpClient = httpClient;
    }
    var _proto = CreateScrapGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return scrap_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/scraps"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CreateScrapGateway;
}();
var DeleteScrapGateway = /*#__PURE__*/ function() {
    "use strict";
    function DeleteScrapGateway(httpClient) {
        scrap_classCallCheck(this, DeleteScrapGateway);
        this.httpClient = httpClient;
    }
    var _proto = DeleteScrapGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return scrap_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "DELETE",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/scraps"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return DeleteScrapGateway;
}();
var GetScrapsCountGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetScrapsCountGateway(httpClient) {
        scrap_classCallCheck(this, GetScrapsCountGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetScrapsCountGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return scrap_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/scraps/count")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetScrapsCountGateway;
}();

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/x-search.ts
function x_search_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function x_search_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                x_search_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                x_search_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function x_search_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

/**
 * 자동완성
 */ var GetXSearchAutoCompleteGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetXSearchAutoCompleteGateway(httpClient) {
        x_search_classCallCheck(this, GetXSearchAutoCompleteGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetXSearchAutoCompleteGateway.prototype;
    _proto.exec = function exec(_param) {
        var _this = this;
        return x_search_asyncToGenerator(runtime_default().mark(function _callee() {
            var _domainNo, domainNo, _maxCount, maxCount, _mode, mode, req;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _domainNo = _param.domainNo, domainNo = _domainNo === void 0 ? 0 : _domainNo, _maxCount = _param.maxCount, maxCount = _maxCount === void 0 ? 10 : _maxCount, _mode = _param.mode, mode = _mode === void 0 ? "s" : _mode, req = _objectWithoutProperties(_param, [
                            "domainNo",
                            "maxCount",
                            "mode"
                        ]);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://xsearch5.hanssem.com:8443/ksf", "/api/suggest"),
                            body: _objectSpread({
                                target: "complete",
                                domain_no: domainNo,
                                max_count: maxCount,
                                mode: mode
                            }, req)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetXSearchAutoCompleteGateway;
}();
/**
 * 추천 검색어
 */ var GetXSearchSuggestGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetXSearchSuggestGateway(httpClient) {
        x_search_classCallCheck(this, GetXSearchSuggestGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetXSearchSuggestGateway.prototype;
    _proto.exec = function exec(_param) {
        var _this = this;
        return x_search_asyncToGenerator(runtime_default().mark(function _callee() {
            var _domainNo, domainNo, _maxCount, maxCount, req;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _domainNo = _param.domainNo, domainNo = _domainNo === void 0 ? 0 : _domainNo, _maxCount = _param.maxCount, maxCount = _maxCount === void 0 ? 10 : _maxCount, req = _objectWithoutProperties(_param, [
                            "domainNo",
                            "maxCount"
                        ]);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://xsearch5.hanssem.com:8443/ksf", "/api/suggest"),
                            body: _objectSpread({
                                target: "related",
                                domain_no: domainNo,
                                max_count: maxCount
                            }, req)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetXSearchSuggestGateway;
}();
var GetXSearchRankingGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetXSearchRankingGateway(httpClient) {
        x_search_classCallCheck(this, GetXSearchRankingGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetXSearchRankingGateway.prototype;
    _proto.exec = function exec(_param) {
        var _this = this;
        return x_search_asyncToGenerator(runtime_default().mark(function _callee() {
            var _domainNo, domainNo, _maxCount, maxCount, req;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _domainNo = _param.domainNo, domainNo = _domainNo === void 0 ? 0 : _domainNo, _maxCount = _param.maxCount, maxCount = _maxCount === void 0 ? 10 : _maxCount, req = _objectWithoutProperties(_param, [
                            "domainNo",
                            "maxCount"
                        ]);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://xsearch5.hanssem.com:8443/ksf", "/api/rankings"),
                            body: _objectSpread({
                                domain_no: domainNo,
                                max_count: maxCount
                            }, req)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetXSearchRankingGateway;
}();

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/notice.ts
function notice_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function notice_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                notice_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                notice_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function notice_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetNoticesGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetNoticesGateway(httpClient) {
        notice_classCallCheck(this, GetNoticesGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetNoticesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return notice_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/notices"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetNoticesGateway;
}()));

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/certification.ts
function certification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function certification_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                certification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                certification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function certification_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


var PostCertificationGateway = /*#__PURE__*/ function() {
    "use strict";
    function PostCertificationGateway(httpClient) {
        certification_classCallCheck(this, PostCertificationGateway);
        this.httpClient = httpClient;
    }
    var _proto = PostCertificationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return certification_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/certification"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return PostCertificationGateway;
}();
var GetCertificationGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetCertificationGateway(httpClient) {
        certification_classCallCheck(this, GetCertificationGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetCertificationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return certification_asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string/* default.stringify */.Z.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/commons/certification?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetCertificationGateway;
}();

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/image-controller.ts
function image_controller_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function image_controller_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                image_controller_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                image_controller_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function image_controller_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var UploadImagesGateway = /*#__PURE__*/ function() {
    "use strict";
    function UploadImagesGateway(httpClient) {
        image_controller_classCallCheck(this, UploadImagesGateway);
        this.httpClient = httpClient;
    }
    var _proto = UploadImagesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return image_controller_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/common-service/api/v1/image/hanssem/images"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return UploadImagesGateway;
}();

;// CONCATENATED MODULE: ../../shared/common/src/adapter/gateway/index.ts








;// CONCATENATED MODULE: ../../shared/common/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/common/src/index.ts




/***/ }),

/***/ 24721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yE": function() { return /* reexport */ DeleteProcessReviewImageGateway; },
  "Qe": function() { return /* reexport */ GetGoodsDisplayOption; },
  "uJ": function() { return /* reexport */ GetInteriorReviewDoneList; },
  "H1": function() { return /* reexport */ GetInteriorReviewOpenList; },
  "nH": function() { return /* reexport */ PutProcessReviewWriteInfoGateway; },
  "WX": function() { return /* reexport */ PutSiteReviewWriteInfoGateway; }
});

// UNUSED EXPORTS: GetProcessReviewWriteInfoGateway, GetSiteReviewWriteInfoGateway, hello

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ../../shared/goods/src/adapter/gateway/goods.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetGoodsDisplayOption = /*#__PURE__*/ function() {
    "use strict";
    function GetGoodsDisplayOption(httpClient) {
        _classCallCheck(this, GetGoodsDisplayOption);
        this.httpClient = httpClient;
    }
    var _proto = GetGoodsDisplayOption.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/").concat(req.gdsNo, "/display/option")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetGoodsDisplayOption;
}();

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ../../shared/goods/src/adapter/gateway/interior-evaluations.ts
function interior_evaluations_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function interior_evaluations_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                interior_evaluations_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                interior_evaluations_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function interior_evaluations_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


var GetInteriorReviewOpenList = /*#__PURE__*/ function() {
    "use strict";
    function GetInteriorReviewOpenList(httpClient) {
        interior_evaluations_classCallCheck(this, GetInteriorReviewOpenList);
        this.httpClient = httpClient;
    }
    var _proto = GetInteriorReviewOpenList.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/open"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetInteriorReviewOpenList;
}();
var GetInteriorReviewDoneList = /*#__PURE__*/ function() {
    "use strict";
    function GetInteriorReviewDoneList(httpClient) {
        interior_evaluations_classCallCheck(this, GetInteriorReviewDoneList);
        this.httpClient = httpClient;
    }
    var _proto = GetInteriorReviewDoneList.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/done"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetInteriorReviewDoneList;
}();
var GetProcessReviewWriteInfoGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetProcessReviewWriteInfoGateway(httpClient) {
        interior_evaluations_classCallCheck(this, GetProcessReviewWriteInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetProcessReviewWriteInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/").concat(req.siteId, "/processes/").concat(req.processId)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetProcessReviewWriteInfoGateway;
}()));
var PutProcessReviewWriteInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function PutProcessReviewWriteInfoGateway(httpClient) {
        interior_evaluations_classCallCheck(this, PutProcessReviewWriteInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = PutProcessReviewWriteInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "PUT",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/").concat(req.siteId, "/processes/").concat(req.processId),
                            body: lodash_default().omit(req, [
                                "siteId",
                                "processId"
                            ])
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return PutProcessReviewWriteInfoGateway;
}();
var DeleteProcessReviewImageGateway = /*#__PURE__*/ function() {
    "use strict";
    function DeleteProcessReviewImageGateway(httpClient) {
        interior_evaluations_classCallCheck(this, DeleteProcessReviewImageGateway);
        this.httpClient = httpClient;
    }
    var _proto = DeleteProcessReviewImageGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "DELETE",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/").concat(req.siteId, "/processes/").concat(req.processId, "/images/").concat(req.intEvalProcImgId)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return DeleteProcessReviewImageGateway;
}();
// 공통 후기 조회
var GetSiteReviewWriteInfoGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetSiteReviewWriteInfoGateway(httpClient) {
        interior_evaluations_classCallCheck(this, GetSiteReviewWriteInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSiteReviewWriteInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/").concat(req.siteId, "/common")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSiteReviewWriteInfoGateway;
}()));
// 공통 후기 작성/수정
var PutSiteReviewWriteInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function PutSiteReviewWriteInfoGateway(httpClient) {
        interior_evaluations_classCallCheck(this, PutSiteReviewWriteInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = PutSiteReviewWriteInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return interior_evaluations_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "PUT",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/goods-service/api/v1/goods/interior-evaluations/").concat(req.siteId, "/common"),
                            body: lodash_default().omit(req, [
                                "siteId"
                            ])
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return PutSiteReviewWriteInfoGateway;
}();

;// CONCATENATED MODULE: ../../shared/goods/src/adapter/gateway/index.ts



;// CONCATENATED MODULE: ../../shared/goods/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/goods/src/index.ts





/***/ })

}]);